window.theme = window.theme || {};

/* ================ SLATE ================ */
window.theme = window.theme || {};

theme.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

theme.Sections.prototype = _.assignIn({}, theme.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (_.isUndefined(constructor)) {
      return;
    }

    var instance = _.assignIn(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    this.instances = _.filter(this.instances, function(instance) {
      var isEventInstance = instance.id === evt.detail.sectionId;

      if (isEventInstance) {
        if (_.isFunction(instance.onUnload)) {
          instance.onUnload(evt);
        }
      }

      return !isEventInstance;
    });
  },

  _onSelect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onSelect)) {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onDeselect)) {
      instance.onDeselect(evt);
    }
  },

  _onBlockSelect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockSelect)) {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockDeselect)) {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(
      function(index, container) {
        this._createInstance(container, constructor);
      }.bind(this)
    );
  }
});

window.slate = window.slate || {};

/**
 * iFrames
 * -----------------------------------------------------------------------------
 * Wrap videos in div to force responsive layout.
 *
 * @namespace iframes
 */

slate.rte = {
  wrapTable: function() {
    $('.rte table').wrap('<div class="rte__table-wrapper"></div>');
  },

  iframeReset: function() {
    var $iframeVideo = $('.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"]');
    var $iframeReset = $iframeVideo.add('.rte iframe#admin_bar_iframe');

    $iframeVideo.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="video-wrapper"></div>');
    });

    $iframeReset.each(function() {
      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

window.slate = window.slate || {};

/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on('click', function(evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).off('focusin');

    $(document).on(eventName, function(evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

theme.Images = (function() {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Swaps the src of an image for another OR returns the imageURL to the callback function
   * @param image
   * @param element
   * @param callback
   */
  function switchImage(image, element, callback) {
    var size = this.imageSize(element.src);
    var imageUrl = this.getSizedImageUrl(image.src, size);

    if (callback) {
      callback(imageUrl, image, element); // eslint-disable-line callback-return
    } else {
      element.src = imageUrl;
    }
  }

  /**
   * +++ Useful
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    if(src.indexOf('@') != -1){
      var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)?\@\d{1,2}x|\d{1,4}x\d{0,4}?@\d{1,2}x|x\d{1,4}?\@\d{1,2}x)[_\.@]/);
    }else{
      var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);
    }
    if (match !== null) {
      return match[1];
    } else {
      return null;
    }
  }
  /**
   * +++ Useful
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size == null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match != null) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    }

    return null;
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }
  
  function nameImage(path) {
    return _.head(_.last(path.split('/')).split('.'));
  }

  return {
    preload: preload,
    loadImage: loadImage,
    switchImage: switchImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol,
    nameImage: nameImage
  };
})();

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 * Alternatives
 * - Accounting.js - http://openexchangerates.github.io/accounting.js/
 *
 */

theme.Currency = (function() {
  var moneyFormat = '${{amount}}'; // eslint-disable-line camelcase

  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = precision == 0 ? 0 : precision || 2;
      thousands = thousands || ',';
      decimal = decimal || '.';

      if (isNaN(number) || number == null) {
        return 0;
      }

      number_ = (number / 100.0).toFixed(precision);

      var parts = number_.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';
      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  }
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist.  Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {

  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();
    this.template = this.originalSelectorId.replace('#ProductSelect-','');

    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
  }

  Variants.prototype = _.assignIn({}, Variants.prototype, {

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = _.map($(this.singleOptionSelector, this.$container), function(element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = _.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {

      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;

      var found = _.find(variants, function(variant) {
        return selectedValues.every(function(values) {
          return _.isEqual(variant[values.index], values.value);
        });
      });

      return found;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this._updateSKU(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      if($('.color_sw.selected .swatch').length != 0){
        var firstVariantImage = $('.color_sw.selected .swatch').css( 'background-image' ).replace('_small_crop_center','').replace(/(url\(|\)|'|")/gi, '');
      }
      var variantImage = variant.featured_image || {};
      var currentVariantImage = $('.product-single__photos-'+this.template + '.SlickPhotoswipGallery .slick-current').attr('data-src') || {};
      if (!variant.featured_image && firstVariantImage == undefined || variantImage.src === currentVariantImage && firstVariantImage == undefined) {
        return;
      }
      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
      
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }
      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant sku changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantSKUChange
     */
    _updateSKU: function(variant) {
      if (variant.sku === this.currentVariant.sku) {
        return;
      }

      this.$container.trigger({
        type: 'variantSKUChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param  {variant} variant - Currently selected variant
     * @return {k}         [description]
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({path: newurl}, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param  {variant} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container).val(variant.id);
    }
  });

  return Variants;
})();


/* ================ GLOBAL ================ */

window.theme = theme || {}; 

theme.getScrollbarWidth = (function(){
  var $inner = jQuery('<div style="width: 100%; height:200px;">test</div>'),
      $outer = jQuery('<div style="width:200px;height:150px; position: absolute; top: 0; left: 0; visibility: hidden; overflow:hidden;"></div>').append($inner),
      inner = $inner[0],
      outer = $outer[0];
  $('body').append(outer);
  var width1 = inner.offsetWidth;
  $outer.css('overflow', 'scroll');
  var width2 = outer.clientWidth;
  $outer.remove();
  return (width1 - width2);
});

/* ================ MODULES ================ */
window.theme = window.theme || {};
theme.MenuReposive = (function() {
  var selectors = {
    body: 'body',
    navigation: '#AccessibleNav',
    siteNavHasDropdown: '.site-nav--has-dropdown',
    siteNavChildLinks: '.site-nav__child-link',
    siteNavActiveDropdown: '.show-submenu',
    siteNavLinkMain: '.site-nav__link--main'
  };

  var config = {
    activeClass: 'show-submenu',
    childLinkClass: 'site-nav__child-link'
  };
  
  function is_mobile(){
    var isMobile = false;
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Opera Mobile|Kindle|Windows Phone|PSP|AvantGo|Atomic Web Browser|Blazer|Chrome Mobile|Dolphin|Dolfin|Doris|GO Browser|Jasmine|MicroB|Mobile Firefox|Mobile Safari|Mobile Silk|Motorola Internet Browser|NetFront|NineSky|Nokia Web Browser|Obigo|Openwave Mobile Browser|Palm Pre web browser|Polaris|PS Vita browser|Puffin|QQbrowser|SEMC Browser|Skyfire|Tear|TeaShark|UC Browser|uZard Web|wOSBrowser|Yandex.Browser mobile/i.test(navigator.userAgent)) isMobile = true;
    return isMobile;
  }
  function init(){
    if(theme.MenuReposive.is_mobile() || $(window).width() <= 768){
      $('.kt-nav').addClass('isMobile').removeClass('notMobile');
    }else{
      $('.kt-nav').removeClass('isMobile').addClass('notMobile');
    }
    $(document).on('click', '#header .kt-nav '+selectors.siteNavHasDropdown, function(e){
      var licurrent = $(this).closest('li');
      var liItem = $('.kt-nav '+selectors.siteNavHasDropdown);
      if (!licurrent.hasClass(config.activeClass)) {
        liItem.removeClass(config.activeClass);
        licurrent.parents().each(function (){
          if($(this).hasClass(selectors.siteNavHasDropdown)){
            $(this).addClass(config.activeClass);
          }
          if($(this).hasClass('main-menu')){
            return false;
          }
        })
        licurrent.addClass(config.activeClass);
        // Close all child submenu if parent submenu is closed
        if ( !licurrent.hasClass(config.activeClass) ) {
          licurrent.find('li').removeClass(config.activeClass);
        }
        return false;
        e.preventDefault();
      }else{
        var href = $(this).attr('href');
        if ( $.trim( href ) == '' || $.trim( href ) == '#' ) {
          licurrent.toggleClass(config.activeClass);
        }
        else{
          window.location = href;
        } 
      }
      // Close all child submenu if parent submenu is closed
      if ( !licurrent.hasClass(config.activeClass) ) {
        licurrent.find('li').removeClass('show-submenu');
      }
      e.stopPropagation();
    });
    $(document).on('click', function(e){
      var target = $( e.target );
      if ( !target.closest(config.activeClass).length || !target.closest('.kt-nav').length ) {
        $('.'+config.activeClass).removeClass(config.activeClass);
      }
    }); 
    // On Desktop
    $(document).on('mouseenter','.kt-nav '+selectors.siteNavHasDropdown,function(){
      if($(this).hasClass(config.activeClass) == false && theme.MenuReposive.is_mobile() == false){$(this).addClass(config.activeClass);}
    })
    $(document).on('mouseleave','.kt-nav '+selectors.siteNavHasDropdown,function(){
      if($(this).hasClass(config.activeClass) && theme.MenuReposive.is_mobile() == false){$(this).removeClass(config.activeClass);}
    })
  }
  function clone_main_menu() {
    var _clone_menu = $('#header .clone-main-menu'),
        _target = $('#box-mobile-menu .clone-main-menu'),
        _data_width = $('#header .main-navigation').data('width');
    if ($(window).innerWidth() <= _data_width) {
      if (_clone_menu.length > 0) {
        _clone_menu.each(function () {
          $(this).appendTo('#box-mobile-menu .box-inner');
        });
      }
    } else {
      if (_target.length > 0) {
        _target.each(function () {
          $(this).appendTo('#header .main-navigation');
        });
      }
    }

    function action_addClass() {
      $('body').addClass('box-mobile-menu-open');
      return false;
    }

    function action_removeClass() {
      $('body').removeClass('box-mobile-menu-open');
      return false;
    }

    $(".mobile-navigation").click(action_addClass);
    $("#box-mobile-menu .close-menu, .body-overlay").click(action_removeClass);
  }
  function box_mobile_menu() {
    var _content = $('#box-mobile-menu .clone-main-menu');
    if ($(window).innerWidth() <= 1024) {
      _content.each(function () {
        var t = $(this);
        t.addClass('active');
        $(this).find('.toggle-submenu').on('click', function () {
          t.removeClass('active');
          var text_next = $(this).prev().text();
          if ($(this).prev().find('.label-menu').length) {
            text_next = text_next.replace($(this).prev().find('.label-menu').text(),'');
          }
          $('#box-mobile-menu .box-title').html(text_next);
          t.find('li').removeClass('mobile-active');
          $(this).parent().addClass('mobile-active');
          $(this).parent().closest('.submenu').css({
            'position': 'static',
            'height': '0',
          });
          $('#box-mobile-menu #back-menu').css('display', 'block');
        })
      });
      $('#box-mobile-menu #back-menu').on('click', function () {
        _content.find('li.mobile-active').each(function () {
          _content.find('li').removeClass('mobile-active');
          if ($(this).parent().hasClass('main-menu')) {
            _content.addClass('active');
            $('#box-mobile-menu .box-title').html('MAIN MENU');
            $('#box-mobile-menu #back-menu').css('display', 'none');
          } else {
            _content.removeClass('active');
            $(this).parent().parent().addClass('mobile-active');
            $(this).parent().css({
              'position': 'absolute',
              'height': 'auto',
            });
            var text_prev = $(this).parent().parent().children('a').text();
            $('#box-mobile-menu .box-title').html(text_prev);
          }
        })
      });
    }
    $('.mobile-navigation').on('click', function () {
      $('body').addClass('box-mobile-menu-open');
    });
    $('#box-mobile-menu .close-menu, .body-overlay').on('click', function () {
      $('body').removeClass('box-mobile-menu-open');
    });
  }
  function unload() {
    $(window).off(selectors.siteNavHasDropdown+' a');
    $(selectors.siteNavHasDropdown).off(selectors.siteNavHasDropdown+' a');
    $(selectors.body).off(selectors.siteNavHasDropdown+' a');
  }

  /* ---------------------------------------------
   STICKY_SCROLLUP
   --------------------------------------------- */
  function sticky_scrollup(){
    if ($(window).width() > 1199) {
      if ($('.menu-sticky-smart .header-wrap-stick').length) {
        var previousScroll = 0,
            headerOrgOffset = $('.header-position').offset().top;
        $('.menu-sticky-smart .header-wrap-stick').outerHeight($('.header-position').outerHeight());
        $(window).scroll(function () {
          var currentScroll = $(this).scrollTop();
          if (currentScroll > headerOrgOffset) {
            if (currentScroll > previousScroll) {
              $('.header-position').addClass('hide-header');
            } else {
              $('.header-position').removeClass('hide-header');
              $('.header-position').addClass('fixed');
              if($('.menu-sticky-smart .header-wrap-stick').hasClass('drd_checked') == false){
                theme.DropdownReposive.init('.header-wrap-stick .kiti--DropWindow','.kiti--DropItem','.kiti--DropInner');
                $('.menu-sticky-smart .header-wrap-stick').addClass('drd_checked')
              }
            }
          } else {
            $('.header-position').removeClass('fixed');
          }
          previousScroll = currentScroll;
        });
      }
    } else {
      $('.menu-sticky-smart .header-wrap-stick').css("height", "auto");
      var previousScroll = 0,
          headerOrgOffset = $('.header-position').offset().top;
      $(window).scroll(function () {
      var currentScroll = $(this).scrollTop();
      if (currentScroll > headerOrgOffset && $('#toolbar').hasClass('action_checked') == false) {
        $('#toolbar').addClass('fixed action_checked');
      } else if (currentScroll < headerOrgOffset){
        $('#toolbar').removeClass('fixed action_checked');
      }
      previousScroll = currentScroll;
    });
    }
  }

  return {
    init: init,
    clone_main_menu: clone_main_menu,
    box_mobile_menu: box_mobile_menu,
    is_mobile: is_mobile,
    sticky_scrollup: sticky_scrollup,
    unload: unload
  };
})();

window.theme = window.theme || {};
theme.ResizeNavMega = (function() {
  var selectors = {
    headerIsVisible: '#header .main-menu-wrapper',
    itemMega: '.main-menu .item-megamenu',
    contentItemMega: '.megamenu'
  };
  function init(scroll){
    var window_size = jQuery('body').innerWidth();
    window_size += theme.getScrollbarWidth();
    if( window_size > 767 ){
      if( $(selectors.headerIsVisible).length >0){
        var container = $(selectors.headerIsVisible);
        if( container!= 'undefined'){
          var container_width = 0;
          container_width = container.innerWidth();
          var container_offset = container.offset();
          setTimeout(function(){
            $(selectors.itemMega).each(function(index,element){
              $(element).children(selectors.contentItemMega).css({'max-width':container_width+'px'});
              var sub_menu_width = $(element).children(selectors.contentItemMega).outerWidth();
              var item_width = $(element).outerWidth();
              $(element).children(selectors.contentItemMega).css({'left':'-'+(sub_menu_width/2 - item_width/2)+'px'});
              var container_left = container_offset.left;
              var container_right = (container_left + container_width);
              var item_left = $(element).offset().left;
              var overflow_left = (sub_menu_width/2 > (item_left - container_left));
              var overflow_right = ((sub_menu_width/2 + item_left) > container_right);
              if( overflow_left ){
                var left = (item_left - container_left);
                $(element).children(selectors.contentItemMega).css({'left':-left+'px'});
              }
              if( overflow_right && !overflow_left ){
                var left = (item_left - container_left);
                left = left - ( container_width - sub_menu_width );
                $(element).children(selectors.contentItemMega).css({'left':-left+'px'});
              }
            })
          },100);
        }
      }
    }
    if( window_size > 991 ){
      $('.megaMaxscroll').each(function(){
        $(this).mThumbnailScroller({
          axis:"y", //change to "y" for vertical scroller
          type:"hover-precise"
        });
      });
    }else if($('.megaMaxscroll').hasClass('mThumbnailScroller')){
      $('.megaMaxscroll').each(function(){
        $(this).mThumbnailScroller("destroy");
      });
    }
    theme.MenuReposive.clone_main_menu();
    if($('#box-mobile-menu .clone-main-menu').length){
      theme.MenuReposive.box_mobile_menu();
    }
    theme.MenuReposive.is_mobile();
    theme.MenuReposive.sticky_scrollup();
  }  
  return {
    init: init
  };
})(jQuery);

window.theme = window.theme || {};
theme.DropdownReposive = (function() {
  function init(windowbase,item,box){
    var selectors = {
      headerIsVisibleDesktop: '.kiti-DropWindowDesktop',
      headerIsVisible: windowbase,
      itemMega: item,
      contentItemMega: box
    };
    var window_size = jQuery('body').innerWidth();
    window_size += theme.getScrollbarWidth();
    if(theme.MenuReposive.is_mobile() === true){
      $(selectors.itemMega).addClass('kiti-DropisMobile').removeClass('kiti-DropisDesktop');
    }
    else{
      $(selectors.itemMega).addClass('kiti-DropisDesktop').removeClass('kiti-DropisMobile');
    }
    if( window_size <= 480 || $(selectors.headerIsVisible).innerWidth() <= 480 ){
      setTimeout(function(){
        $(selectors.itemMega).each(function(index,element){
          var container = $(element).closest(selectors.headerIsVisible);
          if( container.length > 0){
            var container_width = 0;
            container_width = container.innerWidth();
            var container_offset = container.offset();   
            $(element).find(selectors.contentItemMega).css({'max-width':container_width+'px'});
            var sub_menu_width = $(element).find(selectors.contentItemMega).outerWidth();
            var item_width = $(element).outerWidth();
            $(element).find(selectors.contentItemMega).css({'left':'-'+(sub_menu_width/2 - item_width/2)+'px'});
            var container_left = container_offset.left;
            var container_right = (container_left + container_width);
            var item_left = $(element).offset().left;
            var overflow_left = (sub_menu_width/2 > (item_left - container_left));
            var overflow_right = ((sub_menu_width/2 + item_left) > container_right);
            if( overflow_left ){
              var left = (item_left - container_left);
              $(element).find(selectors.contentItemMega).css({'left':-left+'px'});
            }
            if( overflow_right && !overflow_left ){
              var left = (item_left - container_left);
              left = left - ( container_width - sub_menu_width );
              $(element).find(selectors.contentItemMega).css({'left':-left+'px'});
            }
          }
        })
      },100);
    }
    else{
      $(selectors.contentItemMega).css({'max-width':window_size+'px','left':'auto'});
      setTimeout(function(){
        $(selectors.itemMega).each(function(index,element){
          var container = $(element).closest(selectors.headerIsVisibleDesktop);
          if( container.length > 0 && $(element).width() > 0){
            var container_width = 0;
            container_width = container.innerWidth();
            var container_offset = container.offset();   
            $(element).find(selectors.contentItemMega).css({'max-width':container_width+'px'});
            var sub_menu_width = $(element).find(selectors.contentItemMega).outerWidth();
            var item_width = $(element).outerWidth();
            $(element).find(selectors.contentItemMega).css({'left':'-'+(sub_menu_width/2 - item_width/2)+'px'});
            var container_left = container_offset.left;
            var container_right = (container_left + container_width);
            var item_left = $(element).offset().left;
            var overflow_left = (sub_menu_width/2 > (item_left - container_left));
            var overflow_right = ((sub_menu_width/2 + item_left) > container_right);
            if( overflow_left ){
              var left = (item_left - container_left);
              $(element).find(selectors.contentItemMega).css({'left':-left+'px'});
            }
            if( overflow_right && !overflow_left ){
              var left = (item_left - container_left);
              left = left - ( container_width - sub_menu_width );
              $(element).find(selectors.contentItemMega).css({'left':-left+'px'});
            }
          }
        })
      },100);
    }
  }
  return {
    init: init
  };
})();

(function() {
  var selectors = {
    backButton: '.return-link'
  };

  var $backButton = $(selectors.backButton);

  if (!document.referrer || !$backButton.length || !window.history.length) {
    return;
  }

  $backButton.one('click', function(evt) {
    evt.preventDefault();

    var referrerDomain = urlDomain(document.referrer);
    var shopDomain = urlDomain(window.location.href);

    if (shopDomain === referrerDomain) {
      history.back();
    }

    return false;
  });

  function urlDomain(url) {
    var anchor = document.createElement('a');
    anchor.ref = url;

    return anchor.hostname;
  }
})();

theme.Slideshow = (function() {
  this.$slideshow = null;
  var classes = {
    wrapper: 'slideshow-wrapper',
    slideshow: 'slideshow',
    currentSlide: 'slick-current',
    video: 'slideshow__video',
    videoBackground: 'slideshow__video--background',
    closeVideoBtn: 'slideshow__video-control--close',
    pauseButton: 'slideshow__pause',
    isPaused: 'is-paused'
  };

  function slideshow(el) {
    this.$slideshow = $(el);
    this.$wrapper = this.$slideshow.closest('.' + classes.wrapper);
    this.$pause = this.$wrapper.find('.' + classes.pauseButton);
    this.settings = {
      accessibility: true,
      arrows: this.$slideshow.data('arrows'),
      dots: true,
      fade: true,
      draggable: true,
      touchThreshold: 20,
      autoplay: this.$slideshow.data('autoplay'),
      autoplaySpeed: this.$slideshow.data('speed')
    };

    this.$slideshow.on('beforeChange', beforeChange.bind(this));
    this.$slideshow.on('init', slideshowA11y.bind(this));
    this.$slideshow.slick(this.settings);

    this.$pause.on('click', this.togglePause.bind(this));
  }

  function slideshowA11y(event, obj) {
    var $slider = obj.$slider;
    var $list = obj.$list;
    var $wrapper = this.$wrapper;
    var autoplay = this.settings.autoplay;

    // Remove default Slick aria-live attr until slider is focused
    $list.removeAttr('aria-live');

    // When an element in the slider is focused
    // pause slideshow and set aria-live.
    $wrapper.on('focusin', function(evt) {
      if (!$wrapper.has(evt.target).length) {
        return;
      }

      $list.attr('aria-live', 'polite');

      if (autoplay) {
        $slider.slick('slickPause');
      }
    });

    // Resume autoplay
    $wrapper.on('focusout', function(evt) {
      if (!$wrapper.has(evt.target).length) {
        return;
      }

      $list.removeAttr('aria-live');

      if (autoplay) {
        // Manual check if the focused element was the video close button
        // to ensure autoplay does not resume when focus goes inside YouTube iframe
        if ($(evt.target).hasClass(classes.closeVideoBtn)) {
          return;
        }

        $slider.slick('slickPlay');
      }
    });

    // Add arrow key support when focused
    if (obj.$dots) {
      obj.$dots.on('keydown', function(evt) {
        if (evt.which === 37) {
          $slider.slick('slickPrev');
        }

        if (evt.which === 39) {
          $slider.slick('slickNext');
        }

        // Update focus on newly selected tab
        if ((evt.which === 37) || (evt.which === 39)) {
          obj.$dots.find('.slick-active button').focus();
        }
      });
    }
  }

  function beforeChange(event, slick, currentSlide, nextSlide) {
    var $slider = slick.$slider;
    var $currentSlide = $slider.find('.' + classes.currentSlide);
    var $nextSlide = $slider.find('.slideshow__slide[data-slick-index="' + nextSlide + '"]');

    if (isVideoInSlide($currentSlide)) {
      var $currentVideo = $currentSlide.find('.' + classes.video);
      var currentVideoId = $currentVideo.attr('id');
      theme.SlideshowVideo.pauseVideo(currentVideoId);
      $currentVideo.attr('tabindex', '-1');
    }

    if (isVideoInSlide($nextSlide)) {
      var $video = $nextSlide.find('.' + classes.video);
      var videoId = $video.attr('id');
      var isBackground = $video.hasClass(classes.videoBackground);
      if (isBackground) {
        theme.SlideshowVideo.playVideo(videoId);
      } else {
        $video.attr('tabindex', '0');
      }
    }
  }

  function isVideoInSlide($slide) {
    return $slide.find('.' + classes.video).length;
  }

  slideshow.prototype.togglePause = function() {
    var slideshowSelector = getSlideshowId(this.$pause);
    if (this.$pause.hasClass(classes.isPaused)) {
      this.$pause.removeClass(classes.isPaused);
      $(slideshowSelector).slick('slickPlay');
    } else {
      this.$pause.addClass(classes.isPaused);
      $(slideshowSelector).slick('slickPause');
    }
  };

  function getSlideshowId($el) {
    return '#Slideshow-' + $el.data('id');
  }

  return slideshow;
})();

// Youtube API callback
// eslint-disable-next-line no-unused-vars
function onYouTubeIframeAPIReady() {
  theme.SlideshowVideo.loadVideos();
}

theme.SlideshowVideo = (function() {
  var autoplayCheckComplete = false;
  var autoplayAvailable = false;
  var playOnClickChecked = false;
  var playOnClick = false;
  var youtubeLoaded = false;
  var videos = {};
  var videoPlayers = [];
  var videoOptions = {
    ratio: 16 / 9,
    playerVars: {
      // eslint-disable-next-line camelcase
      iv_load_policy: 3,
      modestbranding: 1,
      autoplay: 0,
      controls: 0,
      showinfo: 0,
      wmode: 'opaque',
      branding: 0,
      autohide: 0,
      rel: 0
    },
    events: {
      onReady: onPlayerReady,
      onStateChange: onPlayerChange
    }
  };
  var classes = {
    playing: 'video-is-playing',
    paused: 'video-is-paused',
    loading: 'video-is-loading',
    loaded: 'video-is-loaded',
    slideshowWrapper: 'slideshow-wrapper',
    slide: 'slideshow__slide',
    slideBackgroundVideo: 'slideshow__slide--background-video',
    slideDots: 'slick-dots',
    videoChrome: 'slideshow__video--chrome',
    videoBackground: 'slideshow__video--background',
    playVideoBtn: 'slideshow__video-control--play',
    closeVideoBtn: 'slideshow__video-control--close',
    currentSlide: 'slick-current',
    slickClone: 'slick-cloned',
    supportsAutoplay: 'autoplay',
    supportsNoAutoplay: 'no-autoplay'
  };

  /**
    * Public functions
   */
  function init($video) {
    if (!$video.length) {
      return;
    }

    videos[$video.attr('id')] = {
      id: $video.attr('id'),
      videoId: $video.data('id'),
      type: $video.data('type'),
      status: $video.data('type') === 'chrome' ? 'closed' : 'background', // closed, open, background
      videoSelector: $video.attr('id'),
      $parentSlide: $video.closest('.' + classes.slide),
      $parentSlideshowWrapper: $video.closest('.' + classes.slideshowWrapper),
      controls: $video.data('type') === 'background' ? 0 : 1,
      slideshow: $video.data('slideshow')
    };

    if (!youtubeLoaded) {
      // This code loads the IFrame Player API code asynchronously.
      var tag = document.createElement('script');
      tag.src = 'https://www.youtube.com/iframe_api';
      var firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }
  }

  function customPlayVideo(playerId) {
    // Do not autoplay just because the slideshow asked you to.
    // If the slideshow asks to play a video, make sure
    // we have done the playOnClick check first
    if (!playOnClickChecked && !playOnClick) {
      return;
    }

    if (playerId && typeof videoPlayers[playerId].playVideo === 'function') {
      privatePlayVideo(playerId);
    }
  }

  function pauseVideo(playerId) {
    if (videoPlayers[playerId] && typeof videoPlayers[playerId].pauseVideo === 'function') {
      videoPlayers[playerId].pauseVideo();
    }
  }

  function loadVideos() {
    for (var key in videos) {
      if (videos.hasOwnProperty(key)) {
        var args = $.extend({}, videoOptions, videos[key]);
        args.playerVars.controls = args.controls;
        videoPlayers[key] = new YT.Player(key, args);
      }
    }

    initEvents();
    youtubeLoaded = true;
  }

  function loadVideo(key) {
    if (!youtubeLoaded) {
      return;
    }
    var args = $.extend({}, videoOptions, videos[key]);
    args.playerVars.controls = args.controls;
    videoPlayers[key] = new YT.Player(key, args);

    initEvents();
  }

  /**
    * Private functions
   */

  function privatePlayVideo(id, clicked) {
    var videoData = videos[id];
    var player = videoPlayers[id];
    var $slide = videos[id].$parentSlide;

    if (playOnClick) {
      // playOnClick means we are probably on mobile (no autoplay).
      // setAsPlaying will show the iframe, requiring another click
      // to play the video.
      setAsPlaying(videoData);
    } else if (clicked || (autoplayCheckComplete && autoplayAvailable)) {
      // Play if autoplay is available or clicked to play
      $slide.removeClass(classes.loading);
      setAsPlaying(videoData);
      player.playVideo();
      return;
    }

    // Check for autoplay if not already done
    if (!autoplayCheckComplete) {
      autoplayCheckFunction(player, $slide);
    }
  }

  function setAutoplaySupport(supported) {
    var supportClass = supported ? classes.supportsAutoplay : classes.supportsNoAutoplay;
    $(document.documentElement).addClass(supportClass);

    if (!supported) {
      playOnClick = true;
    }

    autoplayCheckComplete = true;
  }

  function autoplayCheckFunction(player, $slide) {
    // attempt to play video
    player.playVideo();

    autoplayTest(player)
      .then(function() {
        setAutoplaySupport(true);
      })
      .fail(function() {
        // No autoplay available (or took too long to start playing).
        // Show fallback image. Stop video for safety.
        setAutoplaySupport(false);
        player.stopVideo();
      })
      .always(function() {
        autoplayCheckComplete = true;
        $slide.removeClass(classes.loading);
      });
  }

  function autoplayTest(player) {
    var deferred = $.Deferred();
    var wait;
    var timeout;

    wait = setInterval(function() {
      if (player.getCurrentTime() <= 0) {
        return;
      }

      autoplayAvailable = true;
      clearInterval(wait);
      clearTimeout(timeout);
      deferred.resolve();
    }, 500);

    timeout = setTimeout(function() {
      clearInterval(wait);
      deferred.reject();
    }, 4000); // subjective. test up to 8 times over 4 seconds

    return deferred;
  }

  function playOnClickCheck() {
    // Bail early for a few instances:
    // - small screen
    // - device sniff mobile browser

    if (playOnClickChecked) {
      return;
    }

    if ($(window).width() < 750) {
      playOnClick = true;
    } else if (theme.MenuReposive.is_mobile()) {
      playOnClick = true;
    }

    if (playOnClick) {
      // No need to also do the autoplay check
      setAutoplaySupport(false);
    }

    playOnClickChecked = true;
  }

  // The API will call this function when each video player is ready
  function onPlayerReady(evt) {
    evt.target.setPlaybackQuality('hd1080');
    var videoData = getVideoOptions(evt);

    playOnClickCheck();

    // Prevent tabbing through YouTube player controls until visible
    $('#' + videoData.id).attr('tabindex', '-1');

    sizeBackgroundVideos();

    // Customize based on options from the video ID
    switch (videoData.type) {
      case 'background-chrome':
      case 'background':
        evt.target.mute();
        // Only play the video if it is in the active slide
        if (videoData.$parentSlide.hasClass(classes.currentSlide)) {
          privatePlayVideo(videoData.id);
        }
        break;
    }

    videoData.$parentSlide.addClass(classes.loaded);
  }

  function onPlayerChange(evt) {
    var videoData = getVideoOptions(evt);

    switch (evt.data) {
      case 0: // ended
        setAsFinished(videoData);
        break;
      case 1: // playing
        setAsPlaying(videoData);
        break;
      case 2: // paused
        setAsPaused(videoData);
        break;
    }
  }

  function setAsFinished(videoData) {
    switch (videoData.type) {
      case 'background':
        videoPlayers[videoData.id].seekTo(0);
        break;
      case 'background-chrome':
        videoPlayers[videoData.id].seekTo(0);
        closeVideo(videoData.id);
        break;
      case 'chrome':
        closeVideo(videoData.id);
        break;
    }
  }

  function setAsPlaying(videoData) {
    var $slideshow = videoData.$parentSlideshowWrapper;
    var $slide = videoData.$parentSlide;

    $slide.removeClass(classes.loading);

    // Do not change element visibility if it is a background video
    if (videoData.status === 'background') {
      return;
    }

    $('#' + videoData.id).attr('tabindex', '0');

    switch (videoData.type) {
      case 'chrome':
      case 'background-chrome':
        $slideshow
          .removeClass(classes.paused)
          .addClass(classes.playing);
        $slide
          .removeClass(classes.paused)
          .addClass(classes.playing);
        break;
    }

    // Update focus to the close button so we stay within the slide
    $slide.find('.' + classes.closeVideoBtn).focus();
  }

  function setAsPaused(videoData) {
    var $slideshow = videoData.$parentSlideshowWrapper;
    var $slide = videoData.$parentSlide;

    if (videoData.type === 'background-chrome') {
      closeVideo(videoData.id);
      return;
    }

    // YT's events fire after our click event. This status flag ensures
    // we don't interact with a closed or background video.
    if (videoData.status !== 'closed' && videoData.type !== 'background') {
      $slideshow.addClass(classes.paused);
      $slide.addClass(classes.paused);
    }

    if (videoData.type === 'chrome' && videoData.status === 'closed') {
      $slideshow.removeClass(classes.paused);
      $slide.removeClass(classes.paused);
    }

    $slideshow.removeClass(classes.playing);
    $slide.removeClass(classes.playing);
  }

  function closeVideo(playerId) {
    var videoData = videos[playerId];
    var $slideshow = videoData.$parentSlideshowWrapper;
    var $slide = videoData.$parentSlide;
    var classesToRemove = [classes.pause, classes.playing].join(' ');

    $('#' + videoData.id).attr('tabindex', '-1');

    videoData.status = 'closed';

    switch (videoData.type) {
      case 'background-chrome':
        videoPlayers[playerId].mute();
        setBackgroundVideo(playerId);
        break;
      case 'chrome':
        videoPlayers[playerId].stopVideo();
        setAsPaused(videoData); // in case the video is already paused
        break;
    }

    $slideshow.removeClass(classesToRemove);
    $slide.removeClass(classesToRemove);
  }

  function getVideoOptions(evt) {
    return videos[evt.target.h.id];
  }

  function startVideoOnClick(playerId) {
    var videoData = videos[playerId];
    // add loading class to slide
    videoData.$parentSlide.addClass(classes.loading);

    videoData.status = 'open';

    switch (videoData.type) {
      case 'background-chrome':
        unsetBackgroundVideo(playerId, videoData);
        videoPlayers[playerId].unMute();
        privatePlayVideo(playerId, true);
        break;
      case 'chrome':
        privatePlayVideo(playerId, true);
        break;
    }

    // esc to close video player
    $(document).on('keydown.videoPlayer', function(evt) {
      if (evt.keyCode === 27) {
        closeVideo(playerId);
      }
    });
  }

  function sizeBackgroundVideos() {
    $('.' + classes.videoBackground).each(function(index, el) {
      sizeBackgroundVideo($(el));
    });
  }

  function sizeBackgroundVideo($player) {
    var $slide = $player.closest('.' + classes.slide);
    // Ignore cloned slides
    if ($slide.hasClass(classes.slickClone)) {
      return;
    }
    var slideWidth = $slide.width();
    var slideHeight = $slide.height();
    var playerWidth = $player.width();
    var playerHeight = $player.height();
    console.log(slideWidth,slideHeight,playerWidth,playerHeight)

    // when screen aspect ratio differs from video, video must center and underlay one dimension
    if (slideWidth / videoOptions.ratio < playerHeight) {
      console.log(1)
      playerWidth = Math.ceil(playerHeight * videoOptions.ratio); // get new player width
      $player.width(playerWidth).height(playerHeight).css({
        left: (slideWidth - playerWidth) / 2,
        top: 0
      }); // player width is greater, offset left; reset top
    } else { // new video width < window width (gap to right)
      playerWidth = Math.ceil(slideHeight * videoOptions.ratio);
      playerHeight = Math.ceil(slideWidth / videoOptions.ratio); // get new player height
      if (playerWidth >= slideWidth) {
        $player.attr('style', 'width:'+playerWidth+'px;height:'+slideHeight+'px;left:'+(playerWidth - slideWidth) / 2 * -1+'px;top:0;max-width:none !important');
      } else{
        $player.attr('style', 'width:'+slideWidth+'px;height:'+playerHeight+'px;left:0;top:'+(playerHeight - slideHeight) / 2 * -1+'px;max-width:none !important');
      }
       // player height is greater, offset top; reset left
    }

    $player
      .prepareTransition()
      .addClass(classes.loaded);
  }

  function unsetBackgroundVideo(playerId) {
    // Switch the background-chrome to a chrome-only player once played
    $('#' + playerId)
      .removeAttr('style')
      .removeClass(classes.videoBackground)
      .addClass(classes.videoChrome);

    videos[playerId].$parentSlideshowWrapper
      .removeClass(classes.slideBackgroundVideo)
      .addClass(classes.playing);

    videos[playerId].$parentSlide
      .removeClass(classes.slideBackgroundVideo)
      .addClass(classes.playing);

    videos[playerId].status = 'open';
  }

  function setBackgroundVideo(playerId) {
    // Switch back to background-chrome when closed
    var $player = $('#' + playerId)
      .addClass(classes.videoBackground)
      .removeClass(classes.videoChrome);

    videos[playerId].$parentSlide
      .addClass(classes.slideBackgroundVideo);

    videos[playerId].status = 'background';
    sizeBackgroundVideo($player);
  }

  function initEvents() {
    $(document).on('click.videoPlayer', '.' + classes.playVideoBtn, function(evt) {
      var playerId = $(evt.currentTarget).data('controls');
      startVideoOnClick(playerId);
    });

    $(document).on('click.videoPlayer', '.' + classes.closeVideoBtn, function(evt) {
      var playerId = $(evt.currentTarget).data('controls');
      closeVideo(playerId);
    });

    // Listen to resize to keep a background-size:cover-like layout
    $(window).on('resize.videoPlayer', $.debounce(250, function() {
      if (youtubeLoaded) {
        sizeBackgroundVideos();
      }
    }));
  }

  function removeEvents() {
    $(document).off('.videoPlayer');
    $(window).off('.videoPlayer');
  }

  return {
    init: init,
    loadVideos: loadVideos,
    loadVideo: loadVideo,
    playVideo: customPlayVideo,
    pauseVideo: pauseVideo,
    removeEvents: removeEvents
  };
})();

/* ================ TEMPLATES ================ */

window.theme = theme || {};

theme.customerTemplates = (function() {

  function initEventListeners() {
    // Show reset password form
    $('#RecoverPassword').on('click', function(evt) {
      evt.preventDefault();
      toggleRecoverPasswordForm();
    });

    // Hide reset password form
    $('#HideRecoverPasswordLink').on('click', function(evt) {
      evt.preventDefault();
      toggleRecoverPasswordForm();
    });
  }

  /**
   *
   *  Show/Hide recover password form
   *
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

  /**
   *
   *  Show reset password success message
   *
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }

  /**
   *
   *  Show/hide customer address forms
   *
   */
  function customerAddressForm() {
    var $newAddressForm = $('#AddressNewForm');

    if (!$newAddressForm.length) {
      return;
    }

    // Initialize observers on address selectors, defined in shopify_common.js
    if (Shopify) {
      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
        hideElement: 'AddressProvinceContainerNew'
      });
    }

    // Initialize each edit form's country/province selector
    $('.address-country-option').each(function() {
      var formId = $(this).data('form-id');
      var countrySelector = 'AddressCountry_' + formId;
      var provinceSelector = 'AddressProvince_' + formId;
      var containerSelector = 'AddressProvinceContainer_' + formId;

      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
        hideElement: containerSelector
      });
    });

    // Toggle new/edit address forms
    $('.address-new-toggle').on('click', function() {
      $newAddressForm.toggleClass('hide');
    });

    $('.address-edit-toggle').on('click', function() {
      var formId = $(this).data('form-id');
      $('#EditAddress_' + formId).toggleClass('hide');
    });

    $('.address-delete').on('click', function() {
      var $el = $(this);
      var formId = $el.data('form-id');
      var confirmMessage = $el.data('confirm-message');

      // eslint-disable-next-line no-alert
      if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
        Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
      }
    });
  }

  /**
   *
   *  Check URL for reset password hash
   *
   */
  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  return {
    init: function() {
      checkUrlHash();
      initEventListeners();
      resetPasswordSuccess();
      customerAddressForm();
    }
  };
})();

/*================ SECTIONS ================*/
window.theme = window.theme || {};

theme.Cart = (function() {
  var selectors = {
    edit: '.js-edit-toggle'
  };
  var config = {
    showClass: 'cart__update--show',
    showEditClass: 'cart__edit--active',
    cartNoCookies: 'cart--no-cookies'
  };

  function Cart(container) {
    this.$container = $(container);
    this.$edit = $(selectors.edit, this.$container);

    if (!this.cookiesEnabled()) {
      this.$container.addClass(config.cartNoCookies);
    }
    this.$edit.on('click', this._onEditClick.bind(this));
    $.ajax({
      type: 'get',
      url: '/cart.json',
      beforeSend: function() {
      },
      success: function(cart) {
        if (cart.item_count > 0 && theme.function.cartAutoShippingEnable == true) {
          if(cart.items.length === 1 && cart.items[0].requires_shipping == false ){
            return false;
          }
          $.ajax({
            type: 'get',
            url: '//api.teathemes.net/currency',
            success: function(data) {
              if(data.region == 'ENG'){
                var address = {zip: theme.shop.postalCode, country: theme.shop.addressCountry, province: theme.shop.addressLocality}
              }
              else{
                var address = {
                  'zip':data.zip != '' ? data.zip : data.region,
                  'country': data.country,
                  'province': data.regionName
                }
              }
              Shopify.KT_getCartShippingRatesForDestination(address)
            }
          });
        }
      }
    });
  }

  Cart.prototype = _.assignIn({}, Cart.prototype, {
    onUnload: function() {
      this.$edit.off('click', this._onEditClick);
    },

    _onEditClick: function(evt) {
      var $evtTarget = $(evt.target);
      var $updateLine = $('.' + $evtTarget.data('target'));

      $evtTarget.toggleClass(config.showEditClass);
      $updateLine.toggleClass(config.showClass);
    },

    cookiesEnabled: function() {
      var cookieEnabled = navigator.cookieEnabled;

      if (!cookieEnabled){
        document.cookie = 'testcookie';
        cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
      }
      return cookieEnabled;
    }
  });

  return Cart;
})();
window.theme = window.theme || {};

theme.Filters = (function() {
  var constants = {
    SORT_BY: 'sort_by'
  };
  var selectors = {
    filterGroup: '.kt_layerfilterGroups',
    filterGroupDesktop: '.kt_layerfilterGroupsDesktop',
    filterGroupMobile: '.kt_layerfilterGroupsMobile',
    filterLink: 'a[data-pjax-filter]',
    catShowing: '.child_collection li.current-cat'
  };
  function Filters(container) {
    var $container = (this.$container = $(container));
    this._createFilter();
    this._checkCatShowing();
  }

  Filters.prototype = _.assignIn({}, Filters.prototype, {
    _createFilter: function() {
      var filterContent = '';
      var currSearch = window.location.search;
      var currSort = ($('.orderby-wapper li.selected a').attr('href')).replace('?','');
      var currShow = ($('.show-grid-list a.active').attr('href')).replace('?','');
      if(currSearch.indexOf('?sort_by=') >= 0 || currSearch.indexOf('?page=') >= 0 || currSearch.indexOf('?view=') >= 0 || currSearch.indexOf('?q=') >= 0){
        currSearch = '?'+currSearch.split('?')[1];
      }
      else{
        currSearch = '';
      }
      _.forEach(groupsFilter, function(item,idx0) {
        var filterGroupItem  = "";
        if(item.key == 'kt_rencent'){
          filterGroupItem += '<div class="kt_filterGroupItem kt_filterGroupItem'+idx0+' widget widget_recent_product" style="display:none;"><h2 class="widget-title">Recent products</h2><ul class="product-categories">';
          filterGroupItem += '<li class="_"></li>';
          filterGroupItem += '</ul></div>';
        }
        else{
          filterGroupItem += '<div class="kt_filterGroupItem kt_filterGroupItem'+idx0+' blockStyle_'+item.blockStyle+' split_'+item.useSplit+'">';
          filterGroupItem += '<div class="layered_subtitle_heading"><span class="layered_subtitle">'+item.title+'<span></span></span><span class="ico"></span></div>';
          filterGroupItem += '<ul class="kt_filterGroupItem_ul">';
          _.find(collectionTags, function(itemTag) {
            if(itemTag.indexOf(item.key+" ") === 0 && item.tags_import.length === 0){
              if(filterGroupItem.indexOf('_'+_snakeCase(itemTag.replace(item.key+" ",""))) === -1){
                filterGroupItem += '<li class="_'+_handleize(itemTag.replace(item.key+" ",""));
                if(_.indexOf(currTags_handleize, _handleize(itemTag)) >= 0){
                  filterGroupItem += ' tagSelected';
                }
                filterGroupItem += '">';
                filterGroupItem += '<a data-pjax-filter="" href="';
                if(currTags_handleize.length == 0){
                  filterGroupItem += '/collections/'+collection.Crr+'/'+_handleize(itemTag)+currSearch;
                }
                else if(_.indexOf(currTags_handleize, _handleize(itemTag)) >= 0){
                  filterGroupItem += '/collections/'+collection.Crr+'/';
                  _.forEach(currTags_handleize, function(itemCurrentTags) {
                    if(_handleize(itemTag) !== itemCurrentTags){
                      filterGroupItem += itemCurrentTags+'+';
                    }
                  })
                  filterGroupItem += currSearch;
                }else{
                  filterGroupItem += '/collections/'+collection.Crr+'/';
                  _.forEach(currTags_handleize, function(itemCurrentTags) {
                    if(_handleize(itemTag) !== itemCurrentTags){
                      filterGroupItem += itemCurrentTags+'+'
                    }
                  })
                  filterGroupItem += _handleize(itemTag)+currSearch;
                }
                filterGroupItem += '" title="'+itemTag+'">';
                if(colorGroupFilter.indexOf(item.key) !== -1){
                  filterGroupItem += '<span class="color_pick swatch" data-color="'+_handleize(itemTag.replace(item.key+" ",""))+'"></span>';
                }
                if(item.blockStyle === '6'){
                  _.forEach(brands_icon, function(itemBrandIcon) {
                    if(itemBrandIcon.indexOf(_snakeCase(itemTag.replace(item.key+" ",""))) !== -1 || _snakeCase(itemBrandIcon).indexOf(_snakeCase(itemTag.replace(item.key+" ",""))) !== -1){
                      filterGroupItem += '<span class="brand_icon"><img src="';
                      filterGroupItem += itemBrandIcon;
                      filterGroupItem += '"></span>';
                    }
                  });
                }
                filterGroupItem += '<span class="titleFilterItem">'+_.capitalize(itemTag.replace(item.key+" ",""))+'</span>';
                filterGroupItem += '</a>';
                filterGroupItem += '</li>';
              }
            }
            else if(item.tags_import.length > 0){
              _.forEach(item.tags_import, function(item_,idx0) {
                if(_.snakeCase(itemTag) === _.snakeCase(item_) && filterGroupItem.indexOf('_'+_snakeCase(itemTag.replace(item.key+" ",""))) === -1){
                  filterGroupItem += '<li class="_'+_handleize(itemTag);
                  if(_.indexOf(currTags_handleize, _handleize(itemTag)) >= 0){
                    filterGroupItem += ' tagSelected';
                  }
                  filterGroupItem += '">';
                  filterGroupItem += '<a data-pjax-filter="" href="';
                  if(currTags_handleize.length == 0){
                    filterGroupItem += '/collections/'+collection.Crr+'/'+_handleize(itemTag)+currSearch;
                  }
                  else if(_.indexOf(currTags_handleize, _handleize(itemTag)) >= 0){
                    filterGroupItem += '/collections/'+collection.Crr+'/';
                    _.forEach(currTags_handleize, function(itemCurrentTags) {
                      if(_handleize(itemTag) !== itemCurrentTags){
                        filterGroupItem += itemCurrentTags+'+'
                      }
                    })
                    filterGroupItem += currSearch;
                  }
                  else{
                    filterGroupItem += '/collections/'+collection.Crr+'/';
                    _.forEach(currTags_handleize, function(itemCurrentTags) {
                      if(itemTag !== itemCurrentTags){
                        filterGroupItem += itemCurrentTags+'+'
                      }
                    })
                    filterGroupItem += _handleize(itemTag)+currSearch;
                  }
                  filterGroupItem += '" title="'+itemTag+'">';                
                  if(colorGroupFilter.indexOf(item.key) !== -1){
                    filterGroupItem += '<span class="color_pick swatch" data-color="'+_handleize(itemTag)+'"></span>';
                  }
                  if(item.blockStyle === '6'){
                    _.forEach(brands_icon, function(itemBrandIcon) {
                      if(itemBrandIcon.indexOf(_snakeCase(itemTag.replace(item.key+" ",""))) !== -1 || _snakeCase(itemBrandIcon).indexOf(_snakeCase(itemTag.replace(item.key+" ",""))) !== -1){
                        filterGroupItem += '<span class="brand_icon"><img src="';
                        filterGroupItem += itemBrandIcon;
                        filterGroupItem += '"></span>';
                      }
                    });
                  }
                  filterGroupItem += '<span class="titleFilterItem">'+_.capitalize(itemTag)+'</span>';
                  filterGroupItem += '</a>';
                  filterGroupItem += '</li>';
                }
              });
            }
          })
          filterGroupItem += '</ul>';
          filterGroupItem += '</div>';
        }
        if(filterGroupItem.indexOf('<li class="_') !== -1){
          filterContent += filterGroupItem;
        }
      })
      $(selectors.filterGroupDesktop).addClass('colFilter-'+$(filterContent).length);
      if($(window).width() >= 768){
        $(selectors.filterGroupDesktop).html(filterContent);
      }
      else{
        $(selectors.filterGroupMobile).html(filterContent);
        if($('.kt_filterGroupItem').last().hasClass('blockStyle_3') || $('.kt_filterGroupItem').last().hasClass('blockStyle_6') || $('.kt_filterGroupItem').last().hasClass('blockStyle_7')){
          $('.kt_filterGroupItem').last().addClass('showAny')
        }
      }
      recentlyViewedListSidebar();
      if($('.orderby-wapper a').length > 0){
        _.forEach($('.orderby-wapper a'), function(itemOrderby,idx0) {
          var newSort = ($(itemOrderby).attr('href')).replace('?','');
          if(currSearch !== '' && currSearch.indexOf('sort_by=') === -1 && currSearch.indexOf(($(itemOrderby).attr('href')).replace('?','')) === -1){
            $(itemOrderby).attr('href',currSearch+($(itemOrderby).attr('href')).replace('?','&'))
          }
          else if(currSearch !== '' && currSearch.indexOf('sort_by=') !== -1 && currSearch.indexOf(($(itemOrderby).attr('href')).replace('?','')) === -1){
            $(itemOrderby).attr('href',currSearch.replace(currSort,newSort));
          }else if(currSort == newSort){
            $(itemOrderby).attr('href',currSearch);
          }
        });
      }

      if($('.show-grid-list a').length > 0){
        _.forEach($('.show-grid-list a'), function(itemShow,idx0) {
          var newShow = ($(itemShow).attr('href')).replace('?','');
          if(currSearch !== '' && currSearch.indexOf('view=') === -1 && currSearch.indexOf(($(itemShow).attr('href')).replace('?','')) === -1){
            $(itemShow).attr('href',currSearch+($(itemShow).attr('href')).replace('?','&'));
          }
          else if(currSearch !== '' && currSearch.indexOf('view=') !== -1 && currSearch.indexOf(($(itemShow).attr('href')).replace('?','')) === -1){
            $(itemShow).attr('href',currSearch.replace(currShow,newShow));
          }
          // else if(currShow == newShow){
          //   console.log(3)
          //   $(itemShow).attr('href',currSearch);
          // }
        });
      }
      $('#filterApply').html($('.result-count').html());
      $('#filterSelected').html($('.filter-container__selected-filter').html());
      if($(selectors.filterGroup).find('.tagSelected').length > 0){
        $('#filterClear').show();
      }
      else{
        $('#filterClear').hide();
      }
    },
    _checkCatShowing: function() {
      if($(selectors.catShowing).length > 0){
        $(selectors.catShowing).parents('li.level-1').addClass('showAny');
      }
    },
    onUnload: function() {}
  });

  return Filters;
})();

theme.clickOnScrollButton = (function(){
  var viewportHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
  var element = $('.kt_layerFilterJS a[data-action="infinity"]').not('.loading')[0];
  if(element !== undefined && getComputedStyle($('.kt_layerFilterJS').find('.loadMore')[0]).display !== "none" && element.getBoundingClientRect().top <= viewportHeight - 100){
    disableScroll();
    $('.kt_layerFilterJS').find('a[data-action="infinity"]').trigger('click');
  }
});

theme.FiltersPjax = (function(){
  var loadmore = false;
  var scrollTop = null;
  $(document).on('click', 'a[data-pjax-filter]', function(event) {
    if ($.support.pjax) {
      if($(this).attr('data-action') === 'loadmore' || $(this).attr('data-action') === 'infinity' ){
        $.pjax.click(event, {
          container: '.product-listing-loadmore',
          fragment: '.product-listing',
          timeout: 4000,
          scrollTo: false,
          replace: false,
          push: false
        });
        $(this).addClass('loading').text($(this).attr('data-text-loading'));
        if($(this).attr('data-action') === 'infinity'){
          $('.test-loading').show();TweenLite.to('.line-loading', 6, {ease: Expo.easeOut,width: '90%'});
        }
        loadmore = true;
      }
      else{
        $('.test-loading').show();TweenLite.to('.line-loading', 6, {ease: Expo.easeOut,width: '90%'});
        $.pjax.click(event, {
          container: '.kt_layerFilterJS',
          fragment: '.kt_layerFilterJS',
          timeout: 4000,
          scrollTo: false
        });
      }
      if($(this).attr('data-scroll-top') !== undefined){
        scrollTop = true;
        $('div[data-section-id="kt_collection_banner"]').find('img').css('opacity',0.5)
      }
    }
  });
  $(document).on('pjax:success', function() {
    if(loadmore){
      $('.product-listing').find('.product-listing-loadmore').first().addClass('removeElement');
      $('.product-listing').append($('.product-listing').find('.product-listing-loadmore').first().html());
      $('.product-listing').find('.product-listing-loadmore.removeElement').first().remove();
      $('.CountEnd').text($('.product-listing').find('.grid-item').length);
      var CountEnd = $('.CountEnd').text(), AllCount = $('.AllCount').text(), $aMore = $('.pagination_ [data-action]');
      if(+CountEnd < +AllCount){
        var curPage = $aMore.attr('data-page').replace('page_','')
        $aMore.attr('href',$aMore.attr('href').replace('page='+curPage,'page='+(+curPage+1))).attr('data-page','page_'+(+curPage+1));
      }
      else{
        $('.pagination_ .loadMore').hide();
      }
      $aMore.removeClass('loading').text($aMore.attr('data-text-button'));
      $('#filterApply').html($('.result-count').html());
      TweenLite.to('.line-loading', .5,{width: '100%',onComplete: function (e) {$('.test-loading').hide();TweenLite.to('.line-loading', 0, {width: 0});}});
      enableScroll();
    }
    else if(scrollTop == true){
      $('html').animate({scrollTop:0}, 'slow');
      scrollTop = false;
    }
    else{
      var offsetTop = $('.header.ontop').length !== 0 ? $('#PageContainer').offset().top - ($('.header.ontop').height()) * 2 : $('#PageContainer').offset().top - 100;
      $('html').animate({scrollTop:offsetTop}, 'slow');
    }
    if($('.ly__ms').length > 0){
      var loadedImgNum = 0;
      $('.product-listing').imagesLoaded()
      .progress( function( instance, image ) {
        var src = (image.img.src).replace('https:','');
        if ($('img[src="'+src+'"]').closest('.grid-item').attr('style') == undefined){
          $('.product-listing').isotope()
          .append( $('img[src="'+src+'"]').closest('.grid-item') )
          .isotope( 'appended', $('img[src="'+src+'"]').closest('.grid-item') );
        }
      })
      .done( function() {
        $('.product-listing').isotope('layout');
      });
    }
    else if($('.ly__lis').length > 0 || $('.ly__leftlis').length > 0 || $('.ly__leftlis').length > 0){
      var grid_item = '.grid-item.list';
      $('li'+grid_item+' .listThumbScroll').each(function(){
        var $this = $(this);
        var imgLarge = new Image();
        imgLarge.src = $this.parents('li'+grid_item).find('.product-thumb .front-image img').attr('src'); 
        imgLarge.onload = function () {
          $this.css('height',$this.height()+'px');
          $this.find('.ab').removeClass('ab');
          $this.mThumbnailScroller({
            axis:"y", //change to "y" for vertical scroller
            type:"hover-precise"
          });
        }
      });
    }
    loadmore = false;
    theme.checkProductGrid_Width();
    theme.variantCheckStyle();
    if (theme.MenuReposive.is_mobile() == false){
      theme.scrollbarVariantGridProduct();
    }
    theme.floatingAddToCart();
    theme.variantImage();
    theme.variantChange();
    kt_countdown();
    if (typeof window.SPR == 'function') {
      return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges();
    }
  })
  $(document).on('pjax:complete', function() {
    var sections = new theme.Sections();
    sections.register('collection-template', theme.Filters);
    sections.register('banner-page-section',theme.BannerByPage);
    sections.register('masory-section', theme.ProductsMasorySection);    
    TweenLite.to('.line-loading', .5,{width: '100%',onComplete: function (e) {$('.test-loading').hide();TweenLite.to('.line-loading', 0, {width: 0});}});
  });
});

theme.clickProductPopup = (function() {
  function initPhotoSwipe(quickFloating){
    theme.initPhotoSwipeFromDOM('.kt_QuickShopslide','.owl-item:not(.cloned)','IMG', function(getCurrentIndex, currItem){
      var itemOwl = quickFloating.find('.owl-item:not(.cloned) img[src*="'+theme.Images.nameImage(currItem.src)+'_768x."]');
      if($(itemOwl).length !== 0){
        var clone_length = ($('.kt_QuickShopslide .owl-item.cloned').length / 2) || 0;
        var slideIndex = $(itemOwl).parents('.owl-item').not('.cloned').index() - clone_length;
        $(".kt_QuickShopslide").trigger("to.owl.carousel", slideIndex);
      }
    })
  }
  function videoClick(quickFloating){
    $(document).on('click', 'div.kt_floating-quickshop .item-img.video' , function(e) {
      e.preventDefault();
      var vid = quickFloating.find('#myVideo')[0];
      console.log(vid)
      vid.play(); 
      quickFloating.find('#myVideo').bind("play", function() {
        $(this).parent().addClass('playing')
      });
      quickFloating.find('#myVideo').bind("ended", function() {
        $(this).parent().removeClass('playing')
      });
    });
  }
  function imgs360(files,position,width,height,vrId){
    var myModalThreeSixty = '<section class="modal animated fadeIn myModalThreeSixty kt_'+vrId+'" aria-hidden="false" role="dialog" tabindex="-1"> <div class="modal-dialog modal-lg"> <div class="modal-content"> <button class="close animate"> <span aria-hidden="true">×</span> </button> <div class="content-item row"> <div class="threesixty productThreeSixty"> <div class="spinner"> <span>0%</span> </div><ol class="threesixty_images"></ol> </div></div></div></div></section>';
    $('body').append(myModalThreeSixty);
    var options = {
      totalFrames: position[1] - position[0],
      endFrame: position[1] - position[0], 
      currentFrame: 1, 
      imgList: '.threesixty_images', 
      progress: '.spinner',
      imgArray: files,
      width: width,
      height: height,
      responsive: true,
      navigation: true
    }
    $('.productThreeSixty').ThreeSixty(options);
    $(document).on('click','button.pe-360-degrees.kt_open_'+vrId,function(e){
      $('.myModalThreeSixty.kt_'+vrId).modal()
    });
    $(document).on('click','button.close.animate',function(e){
      $(this).closest('.myModalThreeSixty').addClass('fadeOut').animate({opacity: 0}, 400, function(){
        $('.myModalThreeSixty.kt_'+vrId).removeClass('fadeOut').modal('hide')
      });
    });
    $('.myModalThreeSixty.kt_'+vrId).on('hidden.bs.modal', function () {
      $('.productThreeSixty').find('.nav_bar_stop').trigger('click')
    })
  }
  function Click(el){
    var pre_window_width = $(window).outerWidth();
    $(document).on('click',el,function(e){
      var cardwidth = $(this).closest('.product-item');
      if($(this).hasClass('quickshopMobile') && theme.MenuReposive.is_mobile() == false && cardwidth.hasClass('smallCard') == false ){
        var url = $(this).attr('href')
        window.location.href = url;
      }
      else{
        e.preventDefault();
        e.stopPropagation();
        TweenLite.to('.background-overlay', .1, {opacity:"1", visibility:"visible"});
        $('.test-loading').show();
        TweenLite.to('.line-loading', 6, {ease: Expo.easeOut,width: '90%'});
        $('div.kt_floating-quickshop').remove();
        var pInner = $(this).closest('.product-inner'),
            dataJs = pInner.find('.datajs').data(),
            vrId = dataJs.vrid,
            img = pInner.find(".front-image img"),
            position = img.parents('.thumb-inner'),
            positionTop = position[0].getBoundingClientRect().top,
            positionLeft = position[0].getBoundingClientRect().left,
            windowPosition = {
              top: $(window).height() / 2,
              left: $(window).width() / 2
            },
            windowScroll = $(window).scrollTop(),
            prName = pInner.find("h3.product-name").first().html(),
            prHref = dataJs.view,
            vrsPr = pInner.find(".price-attr").first().html() || '',
            imgsPos = _.words(dataJs.imgspos, /[^, ]+/g),
            showbtn360 = false,
            imgsPos360 = _.words(dataJs.imgspos360, /[^, ]+/g),
            vrsVideo = dataJs.vrsvideo,
            wishlistBtn = pInner.find('.wishlist').first().html(),
            closeQuickShop = function(quickFloating){
              $('.closeQuickShop,.background-overlay').on('click touchstart',function(){
                quickFloating.removeClass('open-attr');
                TweenLite.to($('body'), 0,
                  {
                    overflow:'visible',
                    position:'static',
                    marginTop:0,
                    onComplete: function () {
                      $(window).scrollTop(windowScroll)
                    }
                  }
                );
                if($(window).width() < 960){
                  quickFloating.css('pointer-events', 'none');
                  TweenLite.to(quickFloating.find('.kt_headQuickShop'), .2, {top: '-50px'});
                  TweenLite.to(quickFloating, .3, 
                    {
                      opacity: 0,
                      onComplete : function() {
                        $("body").removeClass("MakeFloatingQuickshop");
                        TweenLite.to('.background-overlay', .5,{opacity:0,visibility:"hidden"});
                      }
                    }
                  );
                  setTimeout(function(){
                    quickFloating.remove();
                  }, 1000);
                }
                else{
                  var dataOut = $(this).data();
                  quickFloating.find('.kt_product-buttons,.kt_product-info').removeClass('endanimate');
                  TweenLite.to(quickFloating.find('.kt_headQuickShop'), 0,{opacity:0,visibility:"hidden"});

                  quickFloating.find('.kt_QuickShopslide').owlCarousel('destroy').find('li:not(:first)').remove();
                  quickFloating.find('.kt_QuickShopslide').find('li:first').removeAttr('style');

                  TweenLite.to(quickFloating.find('.kt_product-info'), 0,
                    {
                      overflow: "hidden",
                      opacity: 0,
                      'max-height': 0,
                      'max-width': 0,
                      onComplete : function () {
                        quickFloating.find('.kt_product-info').removeClass('showing');
                        TweenLite.to(quickFloating, .3,
                          {
                            left:windowPosition.left - (480 / 2),
                            width:"480px"
                          }
                        );
                      }
                    }
                  );
                  setTimeout(function(){
                    quickFloating
                    .removeClass('showing')
                    .css({'top' : dataOut.top, 'left' : dataOut.left , 'width' : dataOut.width, 'height' : dataOut.height});
                    setTimeout(function(){
                      $("body").removeClass("MakeFloatingQuickshop");
                      TweenLite.to('.background-overlay', .5, {opacity:0, visibility:"hidden"});
                      quickFloating.remove();
                    }, 500);
                  }, 800);
                }                
                $('.myModalThreeSixty.kt_'+vrId).modal('hide').remove();
              });
              $(window).on("resize", function() {
                if($(window).outerWidth() !== pre_window_width){
                  $('.closeQuickShop').trigger('click')
                  pre_window_width = $(window).outerWidth();
                }
              });
            },
            imgScrollAnimation = function(container){
              if($(window).width() < 960){
                container.scroll(function(event) {
                  if (container.scrollTop() <= $('.kt_product-images').height() && $('.kt_product-images').height() > 50){
                    var transalte = container.scrollTop() / 3;
                    TweenLite.to($('.kt_product-images'), 0,{transform:'translateY('+transalte+'px)'});
                  }else if(container.scrollTop() <= 0){                    
                    TweenLite.to($('.kt_product-images'), 0,{transform:'translateY(0px)'});
                  }
                });
              }
            },
            headScrollAnimation = function(container){
              var previousScroll = 0,
                  headerOrgOffset = 1,
                  quickhead = $('.kt_headQuickShop');
              container.scroll(function (event) {
                var currentScroll = $(this).scrollTop(); 
                var opacity = currentScroll / 300;
                if(opacity <= 1){
                  TweenLite.to(quickhead, .3,{backgroundColor:'rgba(255, 255, 255, '+opacity+')',borderColor: 'rgba(224, 224, 224, '+opacity+')'});
                }else if(opacity > 1){
                  TweenLite.to(quickhead, .3,{backgroundColor:'rgba(255, 255, 255, 1)',borderColor: 'rgba(224, 224, 224, 1)'});
                }
                if(currentScroll - previousScroll < 50 && currentScroll - previousScroll > -50){return false;}
                if (currentScroll > headerOrgOffset) {
                  if (currentScroll > previousScroll) {
                    TweenLite.to(quickhead, .3,{top:-50});
                  } else {
                    TweenLite.to(quickhead, .3,{top:0});
                  }
                }
                else {
                  TweenLite.to(quickhead, .3,{top:0});
                }
                previousScroll = currentScroll;
              });
            },          
            customClick = function(quickFloating){
              quickFloating.find('.kt__qs_custom').click(function(){
                if(quickFloating.hasClass('open-attr')){
                  quickFloating.find('.kt_product-attributes').removeClass('kt_open-more-attrs').find('.kt_more-attrs-content').remove();
                  quickFloating.find('.kt_product-attributes .total-price').remove();
                  quickFloating.find('.kt__add-to-cart').removeAttr('onclick');
                } else {
                  quickFloating.find('.swatches-list strong').first().trigger('click');
                }
                quickFloating.toggleClass('open-attr');
              });
              quickFloating.find('.swatches-list strong').click(function(){
                $(this).parents('.attributes').find('.swatches-list').removeClass('open');
                $(this).parent().addClass('open');
                quickFloating.find('.kt_product-attributes').removeClass('kt_open-more-attrs').find('.kt_more-attrs-content').remove();
                quickFloating.find('.kt_product-attributes .total-price').remove();
                quickFloating.find('.kt__add-to-cart').removeAttr('onclick');
              });
              theme.mobileTouch(quickFloating.find('.attributesScroll'), function(callback){
                if(callback.currentX !== undefined && callback.lastX != callback.currentX){
                  if(callback.deltaX > 30 || callback.deltaX < -30){
                    var currAct = quickFloating.find('.swatches-list.open').index(), nextAct = callback.deltaX > 0 ? currAct - 1 : currAct + 1;
                    quickFloating.find('.swatches-list strong').eq(nextAct == quickFloating.find('.swatches-list').length ? 0 : nextAct).trigger('click');
                  }
                }
              });
            },
            moreAttrs = function(quickFloating){
              quickFloating.find('.more-attrs').click(function(){
                quickFloating.find('.swatches-list').removeClass('open');
                if(quickFloating.find('.kt_product-attributes .kt_more-attrs-content').length <= 0){
                  quickFloating
                  .find('.kt_product-buttons .kt_product-attributes')
                  .addClass('kt_open-more-attrs')
                  .append('<div class="kt_more-attrs-content"></div><div class="total-price"><span class="title">'+theme.strings.titleTotal+':</span><span class="price">'+theme.Currency.formatMoney(0, theme.moneyFormat)+'</span></div>');
                  var dataPjson = JSON.parse(quickFloating.find('#ProductJson')[0].innerHTML);
                  var attrshtml = '<ul class="kt_more-attributes"><form id="kt_addcart-multi">';
                  _.forEach(dataPjson.variants, function(vr, idx) {
                    attrshtml += '<li class="swatch-on-grid itemGroupProducts">';
                    attrshtml += '<input type="checkbox" id="'+vr.id+'" name="id"';
                    attrshtml += vr.available == false ? ' disabled>' : '>';
                    attrshtml += '<input type="number" inputmode="numeric" pattern="[0-9]*" value="0" data-id="'+vr.id+'"';
                    attrshtml += vr.available == false ? ' class="hidden">':'>';
                    attrshtml += '<span class="checkmark"></span><label class="swatch" for="'+vr.id+'" data-vrId="'+vr.id+'" data-vrPrice="'+vr.price+'" data-available="'+vr.available+'" title="'+vr.title+'">'+vr.title+'</label>';
                    attrshtml += '</li>';
                  });
                  attrshtml += '</form></ul>';
                  quickFloating.find('.kt_product-buttons .kt_more-attrs-content').html(attrshtml);
                  quickFloating.find('.kt_more-attrs-content input[type="checkbox"]').change(function(){
                    if (!$(this).is(':checked')) {
                      $(this).parent().find('input[type="number"]').val(0).trigger('change');
                    }
                    else{
                      $(this).parent().find('input[type="number"]').val(1).trigger('change');
                    }
                  })
                  quickFloating.find('.kt_more-attrs-content input[type="number"]').change(function(){
                    var totalPrice = 0;
                    quickFloating.find('.kt_more-attrs-content .itemGroupProducts').each(function(){
                      if ($(this).find('input[type="checkbox"]').is(':checked')) {
                        var qty = $(this).find('input[type="number"]').val(), vrprice = $(this).find('.swatch').attr('data-vrPrice');
                        totalPrice += _.toNumber(vrprice) * _.toNumber(qty)
                      }
                    });
                    quickFloating.find('.total-price .price').html(theme.Currency.formatMoney(totalPrice, theme.moneyFormat))
                  });
                  quickFloating.find('.kt__add-to-cart').attr('onclick',"Shopify.KT_addItemFromMoreAttr('kt_addcart-multi');$(this).addClass('loading').removeClass('loaded')");
                }
                else{
                  quickFloating.find('.kt_product-attributes').toggleClass('kt_open-more-attrs');
                  if(quickFloating.find('.kt_product-attributes').hasClass('kt_open-more-attrs')){
                    quickFloating.find('.kt__add-to-cart').attr('onclick',"Shopify.KT_addItemFromMoreAttr('kt_addcart-multi');$(this).addClass('loading').removeClass('loaded')");
                  }else{
                    quickFloating.find('.kt__add-to-cart').removeAttr('onclick');
                    quickFloating.find('.kt_product-attributes').removeClass('kt_open-more-attrs').find('.kt_more-attrs-content').remove();
                    quickFloating.find('.kt_product-attributes .total-price').remove();
                  }
                }
              });
            },
            createInfo = function(quickFloating){
              $.ajax({
                url: dataJs.view+'?view=infoQuickshop',
                type: 'GET'
              })
              .done(function(data) {
                //  console.log("success");
                if($(window).width() < 960){
                  quickFloating.find('.kt_product-attributes').remove();
                  var optionsPr = data.split('<!-- START OPTIONS -->')[1].split('<!-- END OPTIONS -->')[0],
                      options = optionsPr !== '' ? optionsPr.split('<!-- START -->')[1].split('<!-- END -->')[0] : '';
                  quickFloating.find('.kt_product-info').addClass('showing').find('.kt_product-info-content').addClass('fadeIn').html(data.replace(optionsPr,''));
                  quickFloating.find('.kt_product-buttons').append(options);
                } else {
                  quickFloating.find('.kt_product-info').addClass('showing').find('.kt_product-info-content').addClass('bounceInLeft').html(data);
                }
                quickFloating.find('.kt_product-images .lazyloaded').removeClass('lazyloaded').addClass('lazyload');
                quickFloating.find('.qty').focusin(function() {
                  $(this).trigger('click');
                  // quickFloating.find('.kt_product-buttons').css('bottom', '75px');
                });             
                quickFloating.find('.qty').focusout(function() {
                  quickFloating.find('.kt_product-buttons').removeAttr('style');
                });
                setTimeout(function(){
                  quickFloating.find('.kt_product-buttons,.kt_product-info').addClass('endanimate');
                  if($(window).width() >= 960){quickFloating.find('.kt_product-info').css('overflow','auto');}
                  $('.kt_headQuickShop').css({'opacity': 1});
                  if($(window).width() < 960){
                    theme.DropdownReposive.init('.kiti--DropWindow','.kiti--DropItem','.kiti--DropInner');
                  }
                }, 1000)
              })
              .fail(function() {
                console.log("error info quick shop");
              })
              .always(function() {
                //  console.log("complete")
                theme.Quantity();
                quickFloating.find('.kt_product-attributes .item').addClass('ajaxComplete');
                customClick(quickFloating);
                moreAttrs(quickFloating);
                theme.variantChange('div.kt_floating-quickshop');
                quickFloating.find('.kt_product-attributes span[data-vrid="'+vrId+'"]').first().trigger('click');
                theme.variantCheckStyle();
                kt_countdown();
                theme.stockCountdown('.kt_product-info .kt_progress_bar_pr');                
                TweenLite.to('.line-loading', .5,{width: '100%',onComplete: function (e) {$('.test-loading').hide();TweenLite.to('.line-loading', 0, {width: 0});}});
                //product review
                if (typeof window.SPR == 'function') {
                  return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges();
                }
              })
            },
            positionResize = function(quickFloating){
              $(window).on("resize", function() {
                if($(window).width() >= 960){
                  var windowPositionResize = {
                        top: $(window).height() / 2,
                        left: $(window).width() / 2
                      };
                  quickFloating.css({'top' : windowPositionResize.top - (quickFloating.height() / 2) + 'px', 'left' : windowPositionResize.left - (quickFloating.width() / 2)  + 'px'});
                }
              });
            };
        var imgspr = _.words(dataJs.primgs, /[^, ]+/g), imgs = '', imgsprw = _.words(dataJs.primgswidth, /[^, ]+/g), imgsprh = _.words(dataJs.primgsheight, /[^, ]+/g);
        // Check Product videos available
        if(vrsVideo !== '""' && vrsVideo !== "undefined"){
          var vrsVideoArr = [];
          _.forEach(_.words(vrsVideo, /[^, ]+/g), function(value, idx) {
            var item = new Object();
            item['position'] = value.split(':')[0];
            item['thumb'] = value.split('|http')[0].split(':')[2];
            item['url'] =  value.split('|http')[1].split(':')[1];
            vrsVideoArr.push(item)
          });
        }
        // Check 360 available
        if(imgsPos360 !== '""' && imgsPos360 !== "undefined" && imgsPos360.length > 0){
          showbtn360 = true;
          var files = [];
          _.forEach(imgspr, function(value, idx) {
            if(_.toInteger(imgsPos360[0]) <= idx+1 && idx+1 < _.toInteger(imgsPos360[1])){
              var file = _.replace(dataJs.imgurl, 'kiti', value);
              files.push(file)
            }
          });
          imgs360(files,imgsPos360,imgsprw[imgsPos360[0]],imgsprh[imgsPos360[0]],vrId)
        }
        var widthVisible = $(window).width() >= 480 ? 480 : $(window).width(),
            heightVisible = widthVisible / _.toNumber(img.attr('data-aspectratio'));
            heightVisible < 480 && $(window).width() >= 960 ? heightVisible = 575 : heightVisible = heightVisible;
        if($(window).width() >= 960){
          var visiblePosition = {
            top : windowPosition.top - (heightVisible / 2) + 'px',
            left : windowPosition.left - (widthVisible / 2) + 'px',
            width: widthVisible + 'px',
            height: heightVisible + 'px',
            leftAnimate: windowPosition.left - (960 / 2)  + 'px',
            widthAnimate: '960px'
          }
        }
        else{
          var visiblePosition = {
            top : '0px',
            left : '0px',
            width: widthVisible + 'px',
            height: '100%',
            leftAnimate: '0px',
            widthAnimate: widthVisible
          }
        }
        TweenLite.to($('body'), 0,{overflow:'hidden',position:'fixed',marginTop:windowScroll*-1});
        $("body").append('<div class="kt_floating-quickshop product-inner" style="width: '+position.width()+'px;height: '+position.height()+'px;top:'+positionTop+'px;left:'+positionLeft+'px" data-primgs="'+dataJs.primgs+'" data-primgswidth="'+dataJs.primgswidth+'" data-primgsheight="'+dataJs.primgsheight+'" data-imgurl="'+dataJs.imgurl+'" data-imgspos="'+imgsPos+'" data-imgspos360="'+imgsPos360+'" data-vrsvideo="'+vrsVideo+'">');
        var quickFloating = $('div.kt_floating-quickshop');
        var html = '<div class="quickshop-dialog">';
            html += '<div class="kt_headQuickShop dp-flex flex-nowrap justify-content-between align-items-center align-content-between">';
            html += '<button class="close closeQuickShop" type="button" data-top="'+positionTop+'px" data-left="'+positionLeft+'px" data-width="'+position.width()+'px" data-height="'+position.height()+'px"><span aria-hidden="true">×</span></button>';
            html += '<div class="test"></div><div class="kt_btn-group">';
            if(imgsPos360 !== '""' && imgsPos360 !== "undefined" && imgsPos360.length > 0){
              html += '<button class="pe-360-degrees kt_open_'+vrId+'"></button>';
            }
            if(wishlistBtn !== undefined){
              html += '<div class="wishlist">'+wishlistBtn+'</div>';
            }
            // html += '<button class="kt_shareButtons"><span class="360-sharearrowright"></span></button>';
            html += '</div>';
            html += '</div>';
            html += '<div class="kt_content-quickshop dp-flex">';
            html += '<div class="kt_product-images">';
            if(theme.function.vrsgallery && pInner.find('.quick-view[data-imgpos]').length){
              var imgPos = _.toInteger(pInner.find('.quick-view[data-imgpos]').attr('data-imgpos'));
              var imgspr_ = _.words(imgsPos);
              var imgsPos = [];
              _.forEach(imgspr_, function(value,idx0) {
                if(_.toInteger(value) >= imgPos){
                  imgsPos.push(_.toInteger(value));
                  imgsPos.push(_.toInteger(imgspr_[idx0+1]));
                  return false;
                }
              });
            }
            if(imgspr.length >= 1){
              imgs += '<ul class="kt_QuickShopslide owl-carousel" data-curpos="['+imgsPos[0]+","+imgsPos[1]+']" data-nav="false" data-dots="true" data-loop="false" data-margin="0" data-items="1" data-video="true" data-min-height="'+heightVisible+'">';
              var count = 0;
              var ratio = _.max(imgsprw) / _.max(imgsprh);
              _.forEach(imgspr, function(value, idx) {
                if(idx+1 == imgsPos360[0]){return false}
                if(theme.function.vrsgallery == false || _.toInteger(imgsPos[0]) <= idx+1 && idx+1 < _.toInteger(imgsPos[1]) || _.toInteger(imgsPos[0]) == _.toInteger(imgsPos[1]) && _.toInteger(imgsPos[0]) == idx+1){
                  var fileExt = _.last(value.split('.')), img_url = _.replace(value, '.'+fileExt, '_768x.'+fileExt);
                  var maxCover = imgsprw[idx] >= imgsprh[idx] ? 'max-width' : 'max-height';
                  imgs += '<li class="item-img '+maxCover+'">';
                  if(count == 0){
                    imgs += img[0].outerHTML;
                  }else{
                    imgs += '<img src="'+ _.replace(dataJs.imgurl, 'kiti', img_url) +'" data-srcfix="'+_.replace(dataJs.imgurl, 'kiti', value)+'" data-size="'+imgsprw[idx]+'x'+imgsprh[idx]+'" alt="0711">';
                  }
                  imgs += '</li>';
                  count++;
                }
              });
              var vrvideo = _.find(vrsVideoArr, function(o) { return o.position == imgsPos[0] });
              if(vrvideo !== undefined){
                if((vrvideo.url).indexOf('.mp4') !== -1){
                  imgs += '<li class="item-img video video-lightbox">';
                  if(vrvideo.thumb !== undefined){
                    var fileExtThumb = _.last(vrvideo.thumb.split('.')), img_url_thumb = _.replace(vrvideo.thumb, '.'+fileExtThumb, '_768x.'+fileExtThumb);
                    imgs += '<a href="#"><img src="'+img_url_thumb+'" alt=""></a>';
                  }
                  imgs += '<video class="amp-page amp-video-element" id="myVideo" controls="controls">';
                  imgs += '<source type="video/mp4" src="'+vrvideo.url+'"></video>';
                  imgs += '</li>';
                }else if((vrvideo.url).indexOf('youtube.com') !== -1 || (vrvideo.url).indexOf('vimeo.com') !== -1){
                  imgs += '<li class="item-video video video-lightbox">';
                  imgs += '<a class="owl-video" href="'+vrvideo.url+'"></a>';
                  imgs += '</li>';
                }
              }
              imgs += '</ul>';
            }
            html += imgs;
            html += '</div><div class="kt_product-info"><div class="kt_product-info-content text-left animated"></div></div>';
            html += '</div>';
            html += '<div class="kt_product-buttons dp-flex flex-nowrap justify-content-between align-items-center align-content-between">';
            html += '<div class="kt_product-attributes kiti-DropWindowDesktop"><div class="attributes product-attr"><div class="item"></div></div></div>';
            var soldout = '';
            if(dataJs.action === 'soldout'){soldout = 'hidden'}
            html += '<div class="quantity col '+soldout+'" style="max-width: 150px;">';
            html += '<div class="quantity-inner style2">';
            html += '<div class="quantity-button quantity-down">-</div>';
            html += '<input type="number" inputmode="numeric" id="vr-'+dataJs.vrid+'" name="quantity" value="1" min="1" class="input-text qty text" pattern="[0-9]*">';
            html += '<div class="quantity-button quantity-up">+</div>';
            html += '</div>';
            html += '</div>';
            if(dataJs.action === 'preorder'){
              html += '<button class="button add_to_cart_button kt__add-to-cart col" data-vrid="'+dataJs.vrid+'">'+theme.productStrings.preOrder+'</button>';
            } else if(dataJs.action === 'addtocart'){
              html += '<button class="button add_to_cart_button kt__add-to-cart col" data-vrid="'+dataJs.vrid+'">'+theme.productStrings.addToCart+'</button>';
            } else {
              html += '<button class="button add_to_cart_button kt__add-to-cart col sold_out" data-vrid="'+dataJs.vrid+'" disabled="disabled">'+theme.productStrings.soldOut+'</button>';
            }
            if(dataJs.onlyvr == false){
              if($(window).width() <= 999){
                html += '<div class="button add_to_cart_button kt__qs_custom animated fadeIn col" data-view="'+dataJs.view+'"><span class="pe-7s-angle-up"></span></div>';
              }
              else {
                html += '<div class="button add_to_cart_button kt__qs_custom more-attrs animated fadeIn col" data-view="'+dataJs.view+'"><span class="pe-7s-angle-up"></span></div>';
              }
              //           '+theme.strings.customButton+'
            }
            html += '</div>';
            html += '</div>';
        quickFloating.html(html).addClass('is-visible');
        TweenLite.to(quickFloating, .8,
          {
            ease: Back.easeOut.config(2),
            delay: .3,
            opacity:"1",
            visibility:"visible",
            top: visiblePosition.top,
            left: visiblePosition.left,
            width: visiblePosition.width,
            height: visiblePosition.height,
            onComplete: function() {
              quickFloating.addClass('animated')
              if($(window).width() >= 960){quickFloating.find('.kt_product-info').css('max-height',heightVisible);}
              quickFloating.find('.item-image,.item-video').css('min-height',heightVisible);
              quickFloating.addClass('animate-width showing').animate({'left' : visiblePosition.leftAnimate,'width' : visiblePosition.widthAnimate}, 500, function(){
                createInfo(quickFloating);
              });
              positionResize(quickFloating);
              closeQuickShop(quickFloating);
              theme.floatingAddToCart('div.kt_floating-quickshop');
              // imgScrollAnimation(quickFloating.find('.kt_content-quickshop'));
              headScrollAnimation(quickFloating.find('.kt_content-quickshop'));
              setTimeout(function(){
                $("body").addClass("MakeFloatingQuickshop");
                var owlconfig = quickFloating.find('.kt_QuickShopslide:not(first)').data();
                quickFloating.find('.kt_QuickShopslide:not(first)').owlCarousel(owlconfig);
                videoClick(quickFloating);
                initPhotoSwipe(quickFloating);
              }, 1000);
            }
          }
        );
      }
    });
  }
  return {
    init: Click,
    initPhotoSwipe: initPhotoSwipe,
    videoClick: videoClick,
    imgs360: imgs360
  }
})();

window.theme = window.theme || {};

theme.HeaderSection = (function() {

  function Header() {
    theme.MenuReposive.init();    
    theme.MenuReposive.clone_main_menu(),
    theme.MenuReposive.box_mobile_menu(),
    theme.MenuReposive.sticky_scrollup();
    theme.ResizeNavMega.init();
    // theme.MobileNav.init();
    // theme.Search.init();
  }

  Header.prototype = _.assignIn({}, Header.prototype, {
    onUnload: function() {
      theme.MenuReposive.unload();
    }
  });

  return Header;
})();

theme.Maps = (function() {
  var config = {
    zoom: 14
  };
  var apiStatus = null;
  var mapsToLoad = [];
  var key = theme.mapKey ? theme.mapKey : '';

  function Map(container) {
    this.$container = $(container);

    if (apiStatus === 'loaded') {
      this.createMap();
    } else {
      mapsToLoad.push(this);

      if (apiStatus !== 'loading') {
        apiStatus = 'loading';
        if (typeof window.google === 'undefined') {
          $.getScript('https://maps.googleapis.com/maps/api/js?key=' + key)
            .then(function() {
              apiStatus = 'loaded';
              initAllMaps();
            });
        }
      }
    }
  }

  function initAllMaps() {
    // API has loaded, load all Map instances in queue
    $.each(mapsToLoad, function(index, instance) {
      instance.createMap();
    });
  }

  function geolocate($map) {
    var deferred = $.Deferred();
    var geocoder = new google.maps.Geocoder();
    var address = $map.data('address-setting');

    geocoder.geocode({address: address}, function(results, status) {
      if (status !== google.maps.GeocoderStatus.OK) {
        deferred.reject(status);
      }

      deferred.resolve(results);
    });

    return deferred;
  }

  Map.prototype = _.assignIn({}, Map.prototype, {
    createMap: function() {
      var $map = this.$container.find('.map-section__container');

      return geolocate($map)
        .then(function(results) {
          var mapOptions = {
            zoom: config.zoom,
            center: results[0].geometry.location,
            disableDefaultUI: true
          };

          var map = this.map = new google.maps.Map($map[0], mapOptions);
          var center = this.center = map.getCenter();

          //eslint-disable-next-line no-unused-vars
          var marker = new google.maps.Marker({
            map: map,
            position: map.getCenter()
          });

          google.maps.event.addDomListener(window, 'resize', $.debounce(250, function() {
            google.maps.event.trigger(map, 'resize');
            map.setCenter(center);
          }));
        }.bind(this))
        .fail(function() {
          var errorMessage;

          switch (status) {
            case 'ZERO_RESULTS':
              errorMessage = theme.strings.addressNoResults;
              break;
            case 'OVER_QUERY_LIMIT':
              errorMessage = theme.strings.addressQueryLimit;
              break;
            default:
              errorMessage = theme.strings.addressError;
              break;
          }

          $map
            .parent()
            .addClass('page-width map-section--load-error')
            .html('<div class="errors text-center">' + errorMessage + '</div>');
        });
    },

    onUnload: function() {
      google.maps.event.clearListeners(this.map, 'resize');
    }
  });

  return Map;
})();

// Global function called by Google on auth errors.
// Show an auto error message on all map instances.
// eslint-disable-next-line camelcase, no-unused-vars
function gm_authFailure() {
  $('.map-section').addClass('map-section--load-error');
  $('.map-section__container').remove();
  $('.map-section__link').remove();
  $('.map-section__overlay').after('<div class="errors text-center">' + theme.strings.authError + '</div>');
}

/* eslint-disable no-new */
theme.Product = (function() {
  function Product(container) {
    var $container = this.$container = $(container);
    var sectionId = $container.attr('data-section-id');
    var productsectionId = $container.attr('data-product-id');

    this.settings = {
      // Breakpoints from src/stylesheets/global/variables.scss.liquid
      mediaQueryMediumUp: 'screen and (min-width: 750px)',
      mediaQuerySmall: 'screen and (max-width: 749px)',
      bpSmall: false,
      enableHistoryState: $container.data('enable-history-state') || false,
      imageSize: "530x@2x",
      imageZoomSize: null,
      namespace: '.slideshow-' + sectionId,
      sectionId: sectionId,
      sliderActive: false,
      zoomEnabled: false
    };

    this.selectors = {
      template: '#ProductSection-' + sectionId,
      addToCart: '#AddToCart-' + sectionId,
      addToCartText: '#AddToCartText-' + sectionId,
      comparePrice: '#ComparePrice-' + sectionId,
      originalPrice: '#ProductPrice-' + sectionId,
      variesPrice: '#ProductVaries-' + sectionId,
      SKU: '.variant-sku',
      originalPriceWrapper: '.product-price__price-' + sectionId,
      originalSelectorId: '#ProductSelect-' + sectionId,
      variantSelectorId: '#ProductVariantSelect-' + sectionId,
      productFeaturedImage: '.product-single__photos-' + sectionId + ' .product-single__photo.active-photo',
      productThumbSlick: '.productThumbSlide--' + sectionId,
      productPrices: '.product-single__price-' + sectionId,
      productPhotoImages: '.product-single__photo--' + sectionId,
      productPhotos: '.product-single__photos-' + sectionId,
      productThumbImages: '.product-single__thumbnail--' + sectionId,
      productThumbs: '.product-single__thumbnails-' + sectionId,
      saleClasses: '#ProductSection-' + sectionId + 'product-price__sale product-price__sale--single',
      saleLabel: '.product-price__sale-label-' + sectionId,
      singleOptionSelector: '.single-option-selector-' + sectionId,
      dataSettings: '.datasettings--' + sectionId,
      dataJs: '.datajs--' + sectionId
    }

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$('#ProductJson-' + sectionId).html()) {
      return;
    }

    this.productSingleObject = JSON.parse(document.getElementById('ProductJson-' + sectionId).innerHTML);
    this.dataSettings = $(this.selectors.dataSettings).data();
    this.dataJs = $(this.selectors.dataJs).data();

    if (this.dataSettings.layoutSection !== 3) {
      this._initBreakpoints();
    }
    this._stringOverrides();
    this._initVariants();
    this._initImageSwitch();
    this._create360();
    this._checkVariantVideo();
    if(this.dataSettings.layoutSection == 3){
      this._initStickySummary();
      this._initPhotoSwipeFromDOM();
    }
    // Pre-loading product images to avoid a lag when a thumbnail is clicked, or
    // when a variant is selected that has a variant image
    theme.Images.preload(this.productSingleObject.images, this.settings.imageSize);
    theme.Images.preload(this.productSingleObject.images, '110x110@2x');
  }

  Product.prototype = _.assignIn({}, Product.prototype, {
    _stringOverrides: function() {
      theme.productStrings = theme.productStrings || {};
      $.extend(theme.strings, theme.productStrings);
    },

    _initBreakpoints: function() {
      var self = this;
      // initialize thumbnail slider
      if ($(self.selectors.productThumbImages).length >= 1) {
        self._initThumbnailSlider();
      }
      // initialize photo slider
      if ($(self.selectors.productPhotoImages).length >= 1) {
        self._initPhotoSlider();
      }
    },

    _initVariants: function() {
      var options = {
        $container: this.$container,
        enableHistoryState: this.$container.data('enable-history-state') || false,
        singleOptionSelector: this.selectors.singleOptionSelector,
        originalSelectorId: this.selectors.originalSelectorId,
        product: this.productSingleObject
      };
      this.variants = new slate.Variants(options);
      this.$container.on('variantChange' + this.settings.namespace, this._updateAddToCart.bind(this));
      if(this.dataSettings.layoutSection !== 3){
        this.$container.on('variantImageChange' + this.settings.namespace, this._updateImages.bind(this));
      }
      this.$container.on('variantPriceChange' + this.settings.namespace, this._updatePrice.bind(this));
      this.$container.on('variantSKUChange' + this.settings.namespace, this._updateSKU.bind(this));
    },

    _initImageSwitch: function() {
      if (!$(this.selectors.productThumbImages).length) {
        return;
      }

      var self = this;
      var $originalSelectorId = $(this.selectors.originalSelectorId);
      var $variantSelectorId = this.selectors.variantSelectorId;
      $(document).on('click',this.selectors.productThumbImages, function(evt) {
        evt.preventDefault();
        var $el = $(this);
        var template = self.selectors.template;
        if(typeof $el.attr('data-id') !== "undefined" && $el.attr('data-id') !== '' && $el.attr('title') !== self.productSingleObject.title ){
          $($variantSelectorId+ ' span').text($el.attr('title')).animate({"font-size": "14px"}, 400).animate({"font-size": "13px"}, 500);
          goto = false;
          var opitons = $el.attr('title').split(' / ');
          $(template +' .fake_select li').removeClass('selected');
          $(opitons).each(function(index, opiton) {
            var opitons_change = $(template +' option[value="'+opiton+'"]').val();
            var $opitons_change_ = $(template +' option[value="'+opiton+'"]').parent();
            $(template +' .fake_select li._'+_handleize(opiton)).addClass('selected');
            if(opiton != self.productSingleObject.title){
              $(template +' label[data-change-label="SingleOptionSelector-'+index+'--'+self.settings.sectionId+'"] .text').text(opiton);
              $(template +" .swatches-selected-name[data-change-label='SingleOptionSelector-"+index+"--"+self.settings.sectionId+"] .name").html(opiton);
            }
            if(opitons_change != $opitons_change_.val() ){
              $opitons_change_.val(opitons_change).change();
            }
          });
          var val_id = $el.attr('data-id');
          $originalSelectorId.val(val_id).change();
          if(($(this).parents("div.product-page").data('enable-history-state')) == true){
            var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + val_id;
            window.history.replaceState({path: newurl}, '', newurl);
          }
        }
        var imageSrc = $el.attr('href');
        self._setActiveThumbnail(imageSrc);
      });
    },

    _setActiveThumbnail: function(src) {
      var activeClass = 'active-thumb';
      // If there is no element passed, find it by the current product image
      if (typeof src === 'undefined') {
        src = $(this.selectors.productFeaturedImage).attr('href');
      }
      // Set active thumbnails (incl. slick cloned thumbs) with matching 'href'
      var $thumbnail = $(this.selectors.productThumbImages + '[href="' + src + '"]');
      $(this.selectors.productThumbImages).removeClass(activeClass).parent().find('.placeholder').removeClass(activeClass);
      $thumbnail.addClass(activeClass).parent().find('.placeholder').addClass(activeClass);
      
      var clone_length = ($(this.selectors.productThumbs+' .slick-cloned').length / 2) || 0;
      slideIndex = $thumbnail.parent().not('.slick-cloned').index() - clone_length;
      if($(this.selectors.productPhotos+' .slick-list').length !== 0){$(this.selectors.productPhotos).slick('slickGoTo', slideIndex);}
      $(this.selectors.productThumbImages).removeClass('active-thumb');
      $thumbnail.addClass('active-thumb');
    },

    _switchImage: function(image, zoomImage) {
      // $(this.selectors.productFeaturedImage).attr('src', image);
      // $(this.selectors.productFeaturedImage).parent().attr('href', image);
    },

    _initThumbnailSlider: function() {
      var infinite = true,
          items = 4,
          self = this;
      if(this.dataSettings.imageSize == 'full'){
        items = this.dataSettings.widthSection ? 4 : 5;
      }
      if(this.dataSettings.imageSize == 'medium' || this.dataSettings.imageSize == 'small'){
        items = this.dataSettings.widthSection ? 3 : 4;
      }
      if(this.dataSettings.useThumbVertical){
        items = 5;
        if(this.dataSettings.imageSize == 'medium'){
          items = 4;
        }
        if(this.dataSettings.imageSize == 'small'){
          items = 3;
        }
      }
      if(this.dataSettings.useThumbVertical == false && $('.productThumbSlide--' + this.settings.sectionId + ' .product-single__thumbnails-item').length <= items){
        infinite: false;
      }
      var options = {
        slidesToShow: items,
        infinite: infinite,
        vertical: this.dataSettings.imageSize == 'small' ? false : this.dataSettings.useThumbVertical,
        verticalSwiping: this.dataSettings.imageSize == 'small' ? false : this.dataSettings.useThumbVertical,
        centerMode:false,
        adaptiveHeight: true,
        initialSlide: initialSlide,
        asNavFor: this.selectors.productPhotos,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              vertical: false,
              verticalSwiping: false,
            }
          }
        ]
      };
      $(this.selectors.productThumbs+':not(.first) li:not(.slick-cloned)').eq(options.slidesToShow-1).addClass('last');
      if(this.dataSettings.useThumb === true && this.dataSettings.imageSize !== 'full'){
        var imgLarge = new Image();
        imgLarge.src = $(self.selectors.productThumbs+':not(.first)').find('img').first().attr('src'); 
        imgLarge.onload = function () {
          $(self.selectors.productThumbs+':not(.first)').attr('data-items',options.slidesToShow).slick(options);
        }
      }

      // On after slide change
      $(this.selectors.productThumbs+':not(.first)').on('beforeChange', function(event, slick, currentSlide, nextSlide){
        var options_ = $(self.selectors.productThumbs+':not(.first)').slick('getSlick');
        var lastSlickActive = options_.currentSlide + options_.options.slidesToShow;
        $(self.selectors.productThumbs+':not(.first)').find('li.last').removeClass('last');
        $(self.selectors.productThumbs+':not(.first) li:not(.slick-cloned)').eq(lastSlickActive).addClass('last');
      });
    },

    _destroyThumbnailSlider: function() {
      $(this.selectors.productThumbs).slick('unslick');
      this.settings.sliderActive = false;
    },
    
    _initPhotoSlider: function() {
      var slidesToShow = 1,
          slidesToScroll = 1,
          fade = true,
          self = this;
      if(this.dataSettings.imageSize == 'full'){
        fade = false;
        slidesToShow = this.dataSettings.widthSection ? 2 : 3,
        slidesToScroll = this.dataSettings.widthSection ? 2 : 3;
      }
      if(this.dataSettings.useThumb && this.dataSettings.imageSize !== 'full'){
        var options = {
          dots: false,
          speed: 300,
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows:false,
          adaptiveHeight: true,
          fade: true,
          initialSlide: initialSlide || 0,
          cssEase: 'linear',
          asNavFor: this.selectors.productThumbs
        };
      }else{
        var options = {
          dots: true,
          speed: 300,
          slidesToShow: slidesToShow,
          slidesToScroll: slidesToScroll,
          arrows:true,
          adaptiveHeight: true,
          fade: fade,
          initialSlide: initialSlide || 0,
          cssEase: 'linear'
        };
      }
      var imgLarge = new Image();
      imgLarge.src = $(this.selectors.productPhotos+':not(.first)').find('img').first().attr('data-src'); 
      imgLarge.onload = function () {
        $(self.selectors.productPhotos+':not(.first)').slick(options);
        self._initPhotoSwipeFromDOM();
        // self._getColorsImage();
      }
    },

    _getColorsImage: function() {
      var self = this;
      var img = document.createElement('img');
      console.log($('.slick-active '+self.selectors.productThumbImages+ ' img'))
      img.setAttribute('src', $('.slick-active '+self.selectors.productThumbImages+ ' img').attr('src').replace('110x110@2x','200x1_crop_center'))
      $(img).chameleon("getImageColors", {
        "onGetColorsSuccess": function(colors, $container, s) {
          $('.product-details-full').css('background-color','#'+colors[1].hex); 
        },
        "onGetColorsError": function(colors, $container, s, img_src) {
          console.log('Error occurred on getImageColors!'); 
        }
      });
    },

    _destroyPhotoSlider: function() {
      $(this.selectors.productPhotos).slick('unslick');
    },

    _initPhotoSwipeFromDOM: function() {
      var self = this;
      theme.initPhotoSwipeFromDOM(this.selectors.template+' .SlickPhotoswipGallery','.grid__item:not(.slick-cloned)','IMG', function(currentIndex, currentItem){
        if($(self.selectors.template+' .SlickPhotoswipGallery .slick-list').length !== 0){
          var itemSlick = $(self.selectors.template+' .SlickPhotoswipGallery').find('.slick-slide:not(.slick-cloned)[data-src="'+currentItem.src+'"]');
          if($(itemSlick).length !== 0){
            var clone_length = ($(self.selectors.template+' .SlickPhotoswipGallery .slick-slide.slick-cloned').length / 2) || 0;
            var slideIndex = $(itemSlick).index() - clone_length;
            $(self.selectors.template+' .SlickPhotoswipGallery').slick('slickGoTo', slideIndex);
          }
        }
      });
    },

    _initStickySummary: function() {
      var thissummary = $('.summary.entry-summary');
      var thissummaryw = thissummary.width();
      var thissummaryo = thissummary.offset();
      var thisposition = $(window).scrollTop() + thissummary[0].getBoundingClientRect().top;
      $(window).scroll(function() {
        // console.log(thissummary[0].getBoundingClientRect().top + thissummary.height())
        var thissummaryh = thissummary.height() + 50;
        if (thissummary !== undefined && $(window).width() >= 768) {
          if ($('.product-page').height() - 30 > $(window).scrollTop() + thissummaryh - thisposition) {
            if ($(window).scrollTop() >= thisposition){
              var transalte = $('.header-position.fixed:not(.hide-header)').length > 0 ? 100 : 20;
              thissummary.not('.fixed').addClass('fixed').removeClass('maxscroll').css({'top': transalte+'px','width': thissummaryw+'px','transform': 'none'});
            }else if($(window).scrollTop() < thisposition){
              thissummary.removeClass('fixed maxscroll').removeAttr('style');
            }
          } else if (thissummary.hasClass('maxscroll') == false && $('.product-page').height() - 30 <= thissummaryh + thissummary.offset().top) {
            var transalte = $('.header-position.fixed:not(.hide-header)').length > 0 ? $('.product-page').height() - thissummaryh + 100 : $('.product-page').height() - thissummaryh + 20;
            thissummary
            .addClass('maxscroll')
            .removeClass('fixed')
            .removeAttr('style')
            .css({'transform': 'translate3d(0px,'+transalte+'px,0px)','-webkit-transform': 'translate3d(0px,'+transalte+'px,0px)','moz-transform': 'translate3d(0px,'+transalte+'px,0px)','-ms-transform': 'translate3d(0px,'+transalte+'px,0px)','-o-transform': 'translate3d(0px,'+transalte+'px,0px)'});
          }
        }
      });
    },

    _updateAddToCart: function(evt) {
      var variant = evt.variant;
      var template = this.selectors.template;
      var sectionId = this.settings.sectionId;
      // console.log(template)
      if($('#SingleOptionSelector-0--'+sectionId+'').val() !== undefined ){
        $('#callBackVariant--'+sectionId).attr('class','_'+_handleize($('#SingleOptionSelector-0--'+sectionId).val()));
        if($('#SingleOptionSelector-2--'+sectionId+'').val() !== undefined ){
          $('#callBackVariant--'+sectionId).addClass('_'+_handleize($('#SingleOptionSelector-2--'+sectionId).val()));
        }
        if($('#SingleOptionSelector-1--'+sectionId+'').val() !== undefined ){
          $('#callBackVariant--'+sectionId).addClass('_'+_handleize($('#SingleOptionSelector-1--'+sectionId).val()));
        }
      }
      if (variant) {
        if(sectionId !== this.productSingleObject.id){this._updateGallery(variant);}
        $(this.selectors.variantSelectorId+ ' span').text(variant.title).animate({"font-size": "14px"}, 400).animate({"font-size": "13px"}, 500);
        $(this.selectors.productPrices).removeClass('visibility-hidden').attr('aria-hidden', 'true');   
        if (variant.available) {
          $(template).find('.kt_progress_bar').removeClass('hidden');
          $(template).find('.availalbe.text-primary').text(theme.strings.inStock);
          $(template).find('.product-form__item--quantity').removeClass('hidden');
          if (variant.inventory_quantity > 0 && variant.inventory_management !== null) {
            $(template).find('.meta .show-iq span').text(variant.inventory_quantity).removeClass('hidden');
            $(template).find('.meta .show-iq_').removeClass('min');
          }else{
            $(template).find('.meta .show-iq').addClass('hidden');
            $(template).find('.meta .show-iq_').addClass('min');
          }          
          if($(template).find('.summary .discount-code').length > 0){
            var btn = $(template).find('.summary .discount-code a.discount-btn'), hrefcrr = btn.attr('href'), vridcrr = btn.attr('href').split('/')[2].split(':')[0];
            btn.attr('href', _.replace(hrefcrr, vridcrr, variant.id));
          }
        } else {
          $(template).find('.kt_progress_bar').addClass('hidden');
          $(template).find('.availalbe.text-primary').text(theme.strings.outOfStock);
          $(template).find('.product-form__item--quantity,.meta .show-iq').addClass('hidden');
          $(template).find('.meta .show-iq_').addClass('min');
        }        
        if (variant.available || variant.available && variant.inventory_quantity <= 0 && variant.inventory_policy != 'deny') {
          $(this.selectors.addToCart).prop('disabled', false);
          if (variant.inventory_quantity <= 0 && variant.inventory_policy != 'deny'){
            $(this.selectors.addToCartText).text(theme.strings.preOrder);
          }else{
            $(this.selectors.addToCartText).text(theme.strings.addToCart);
          }
          $(template).find('.shopifyPaymentButton').show()
        } else {
          $(this.selectors.addToCart).prop('disabled', true);
          $(this.selectors.addToCartText).text(theme.strings.soldOut);
          $(template).find('.shopifyPaymentButton').hide()
        }
      } else {
        if(goto == true){
          var opitons = first_available.split(' / ');
          var opitons_title = first_available_title.split(' / ');
          var option1_cr = $(template+' #SingleOptionSelector-0--'+sectionId+' option:selected').attr('data-value');
          $(template +' .fake_select li').removeClass('selected')
          $(opitons).each(function(index, opiton) {
            if(index === 0 && opiton !== option1_cr ){
              $(template +' .fake_select li._'+option1_cr).addClass('selected');
            }
            else if(index === 2 && opiton !== option1_cr ){
              $(template+' li[data-change-option="SingleOptionSelector-2--'+sectionId+'"]').each(function(index,el){
                if($(this).is(":visible")){
                  $(this).addClass('selected');
                  var opitons_change = $(this).attr('data-value');
                  var $opitons_change_ = $(template+' #SingleOptionSelector-2--'+sectionId);
                  if(opitons_change != $opitons_change_.val()){
                    $opitons_change_.val(opitons_change).change();
                    $(template +' label[data-change-label="SingleOptionSelector-2--'+sectionId+'"] .text').text($(this).attr('title'));
                  }
                  return false;
                }
              });
            }
            else{
              var opitons_change = $(template +" option[value='"+opitons_title[index]+"']").val();
              var $opitons_change_ = $(template +" option[value='"+opitons_title[index]+"']").parent();
              $(template +' .fake_select li._'+opiton).addClass('selected');
              $(template +' label[data-change-label="SingleOptionSelector-'+index+'--'+sectionId+'"] .text').text(opitons_title[index]);
              if(opitons_change != $opitons_change_.val()){
                $opitons_change_.val(opitons_change).change();
              }
            }
          });
        }
      }
    },

    _updateImages: function(evt) {
      var variant = evt.variant;
      if(!variant.featured_image){        
        var variantImage = $(this.selectors.template +' .color_sw.selected .swatch').css( 'background-image' ).replace('_small_crop_center','').replace(/(url\(|\)|'|")/gi, '');
      }else{
        var variantImage = variant.featured_image.src;
      }
      var sizedImgUrl = theme.Images.getSizedImageUrl(variantImage, this.settings.imageSize);
      
      if(this.dataSettings.useThumb){
        if(variantImage != undefined && goto == true ){
          var $thumbnail = $(this.selectors.productThumbs+' '+this.selectors.productThumbImages + '[href="' + variantImage.replace('https:', '') + '"]');
          var clone_length = $(this.selectors.productThumbs+' .slick-cloned').length / 2;
          slideIndex = $thumbnail.parent().not('.slick-cloned').index() - clone_length;
          if($(this.selectors.productPhotos+' .slick-list').length !== 0){$(this.selectors.productPhotos).slick('slickGoTo', slideIndex);}
          if($(this.selectors.productThumbs+' .slick-list').length !== 0){
            $(this.selectors.productThumbs).slick('slickGoTo', slideIndex);
            $(this.selectors.productThumbImages).removeClass('active-thumb');
            $thumbnail.addClass('active-thumb');
          }else{
            $(this.selectors.productThumbImages).removeClass('active-thumb');
            $thumbnail.addClass('active-thumb');
          }          
          // this._getColorsImage();
        }
      }else{
        if(variantImage != undefined && goto == true ){
          var $photo = $(this.selectors.productPhotos+' '+this.selectors.productPhotoImages + '[href="' + variantImage.replace('https:', '') + '"]');
          slideIndex = $photo.parent().not('.slick-cloned').index() >= 0 ? $photo.parent().not('.slick-cloned').index() : 0;
          if($(this.selectors.productPhotos+' .slick-list').length !== 0){$(this.selectors.productPhotos).slick('slickGoTo', slideIndex);}          
          // this._getColorsImage();
        }
      }
    }, 
    
    _updateGallery: function(variant) {
      var self = this;
      var dataJs = this.dataJs;
      var imgPos = variant.featured_image ? variant.featured_image.position : _.toInteger($(this.selectors.dataJs).attr('data-vrimgpos'));
      var imgspr = _.words(dataJs.imgspos, /[^, ]+/g) , templateSlick = self.settings.sectionId;
      var htmlPhotoImages = '<div class="photos-wrapper pr"><ul class="grid grid--uniform SlickPhotoswipGallery product-single__photos product-single__photos-'+templateSlick+'">';
      var htmlThumbImages = '<div class="thumbnails-wrapper pr" style="display:none;"><ul class="grid grid--uniform product-single__thumbnails product-single__thumbnails-'+templateSlick+'">';   
      var last_imgPos = $(this.selectors.dataJs).attr('data-vrimgpos');
      if(_.indexOf(imgspr,_.toString(imgPos)) !== -1 && last_imgPos !== _.toString(imgPos) && this.dataSettings.gallery){
        var imgsPos = [];
        _.forEach(imgspr, function(value,idx0) {
          if(_.toInteger(value) >= imgPos){
            imgsPos.push(_.toInteger(value));
            imgsPos.push(_.toInteger(imgspr[idx0+1]));
            return false;
          }
        });
        if(dataJs.vrsvideo !== '""' && dataJs.vrsvideo !== "undefined"){
          var vrsVideoArr = [];
          _.forEach(_.words(dataJs.vrsvideo, /[^, ]+/g), function(value, idx) {
            var item = new Object();
            item['position'] = value.split(':')[0];
            item['thumb'] = value.split('|http')[0].split(':')[2];
            item['url'] =  value.split('|http')[1].split(':')[1];
            vrsVideoArr.push(item)
          });
        }
        if(imgspr.length > 1 && JSON.parse($(this.selectors.dataJs).attr('data-curpos')) !== imgsPos){
          $(this.selectors.template +' .loadingChangeImage').css('display','block');
          $(this.selectors.dataJs).attr('data-curpos','['+imgsPos[0]+","+imgsPos[1]+']');
          variant.featured_image ? $(this.selectors.dataJs).attr('data-vrimgpos',variant.featured_image.position) : $(this.selectors.dataJs).attr('data-vrimgpos',imgsPos[0]);
          var imgsArray = _.words(dataJs.primgs, /[^, ]+/g), imgsprw = _.words(dataJs.primgswidth, /[^, ]+/g), imgsprh = _.words(dataJs.primgsheight, /[^, ]+/g);
          if( $(this.selectors.productThumbs).length > 0){
            var image_size = theme.Images.imageSize($(this.selectors.productThumbs+" .product-single__thumbnail-image:first").attr('src'));
          }
          var image_size_ = theme.Images.imageSize($(this.selectors.productPhotos+" .product-single__photo-image:first").attr('src'));
          var count_img = 0;
          _.forEach(imgsArray, function(value, idx) {
            if(_.toInteger(imgsPos[0]) <= idx+1 && idx+1 < _.toInteger(imgsPos[1]) || _.toInteger(imgsPos[0]) == _.toInteger(imgsPos[1]) && _.toInteger(imgsPos[0]) == idx+1){
              var fileExt = _.last(value.split('.')), img_url_thumb = _.replace(value, '.'+fileExt, '_'+image_size+'.'+fileExt), img_url_photo = _.replace(value, '.'+fileExt, '_'+image_size_+'.'+fileExt);
              var altobj = _.find(self.productSingleObject.variants, function(o) { return o.id == dataJs.vrsFeaturedImg[idx].id});
              var alt = altobj !== undefined ? altobj.featured_image.alt : self.productSingleObject.title;
              htmlPhotoImages += '<li class="grid__item product-single__photos-item">';
              htmlPhotoImages += '<a href="'+_.replace(dataJs.imgurl, 'kiti', img_url_photo)+'" class="gallery-image product-single__photo product-single__photo--'+templateSlick+'">';
              htmlPhotoImages += '<img class="product-single__photo-image img-responsive lazyload" data-src="'+ _.replace(dataJs.imgurl, 'kiti', img_url_photo) +'" data-srcfix="'+_.replace(dataJs.imgurl, 'kiti', value)+'" data-size="'+imgsprw[idx]+'x'+imgsprh[idx]+'" alt="'+alt+'">';
              htmlPhotoImages += '</a></li>';
              if( $(self.selectors.productThumbs).length > 0){
                htmlThumbImages += '<li class="grid__item product-single__thumbnails-item">';
                htmlThumbImages += '<a href="'+_.replace(dataJs.imgurl, 'kiti', value)+'" class="text-link product-single__thumbnail product-single__thumbnail--'+templateSlick+'"';
                htmlThumbImages += ' title="'+dataJs.vrsFeaturedImg[idx].title+'"';
                htmlThumbImages += ' data-src="'+_.replace(dataJs.imgurl, 'kiti', value)+'"';
                htmlThumbImages += ' data-id="'+dataJs.vrsFeaturedImg[idx].id+'">';
                htmlThumbImages += '<img class="product-single__thumbnail-image img-responsive" src="'+ _.replace(dataJs.imgurl, 'kiti', img_url_thumb) +'" alt="'+self.productSingleObject.title+'">';
                htmlThumbImages += '</a></li>';
              }
              count_img++
            }
          });
          htmlPhotoImages += '</ul></div>';
          htmlThumbImages += '</ul></div>';
          var templateImages = self.selectors.template;
          if( count_img > 1){
            $(templateImages +' .main-image').removeAttr('style');
            $(templateImages +' .thumbnails-wrapper').removeAttr('style');
          }else{
            $(templateImages +' .main-image').css({'padding': '0','width': '100%'});
            $(templateImages +' .thumbnails-wrapper').css('display','none');
          }
          $(this.selectors.template).find('.photos-wrapper').addClass('first');
          $(this.selectors.template).find('.thumbnails-wrapper').addClass('first');
          $(this.selectors.productPhotos).first().addClass('first');
          $(this.selectors.productThumbs).first().addClass('first');
          if($(self.selectors.productThumbs+' .slick-list').length !== 0){
            this._destroyThumbnailSlider();
          }
          if($(self.selectors.template+' .SlickPhotoswipGallery .slick-list').length !== 0){
            this._destroyPhotoSlider();
          }
          if( $(this.selectors.productThumbs).length > 0){
            $(this.selectors.template).find('#product-thumb-slide').append(count_img > 1 ? _.replace(htmlThumbImages,' style="display:none;"','') : htmlThumbImages)
            .animate({'opacity': 1},'0', function() {
              var imgLarge = new Image();
              imgLarge.src = $(htmlThumbImages).find('img').first().attr('src'); 
              imgLarge.onload = function () {
                $(self.selectors.template +' .loadingChangeImage').css('display','none');
                self._initThumbnailSlider();
                $(self.selectors.template).find('.thumbnails-wrapper.first').animate({'opacity': 0},'100', function() {
                  $(this).remove();
                });
                if($(self.dataSettings.useThumb)){
                  self._setActiveThumbnail();
                }
              }
            })
          }
          $(this.selectors.template).find('.main-image-wapper').append(htmlPhotoImages).animate({'opacity': 1},'0', function() {
            var imgLarge = new Image();
            imgLarge.src = $(htmlPhotoImages).find('img').first().attr('data-src'); 
            imgLarge.onload = function () {
              $(self.selectors.template +' .loadingChangeImage').css('display','none');
              if(self.dataSettings.layoutSection !== 3){
                self._initPhotoSlider();
              }else if(self.dataSettings.layoutSection == 3){
                self._initPhotoSwipeFromDOM();
              }
              $(self.selectors.template).find('.photos-wrapper.first').animate({'opacity': 0},'100', function() {
                $(this).remove();
              })
            }
          })

          var vrvideo = _.find(vrsVideoArr, function(o) { return o.position == imgsPos[0] });
          if(vrvideo !== undefined){
            $('.pe-7s-play.kt_openvd_'+this.productSingleObject.id).removeClass('hidden');
            if((vrvideo.url).indexOf('.mp4') !== -1){
              $('.pe-7s-play.kt_openvd_'+this.productSingleObject.id)
              .magnificPopup({
                items: [
                  {
                    src: '<div class="white-popup"><div class="white-popupcontent"><video class="amp-page amp-video-element" id="myVideo_product" controls="controls" autoplay><source type="video/mp4" src="'+vrvideo.url+'"></video></div></div>',
                    type: 'inline'
                  }
                ],
                type: 'image'
              });
            }else if((vrvideo.url).indexOf('youtube.com') !== -1 || (vrvideo.url).indexOf('vimeo.com') !== -1){
              $('.pe-7s-play.kt_openvd_'+this.productSingleObject.id)
              .magnificPopup({
                items: [
                  {
                    src: vrvideo.url,
                    type: 'iframe'
                  }
                ],
                type: 'image'
              });
            }
          }else{
            $('.pe-7s-play.kt_openvd_'+this.productSingleObject.id).addClass('hidden');
          }
        }
      }
    },

    _checkVariantVideo: function() {
      var dataJs = this.dataJs;
      var imgspr = _.words(dataJs.imgspos, /[^, ]+/g);
      var imgPos = this.variants.currentVariant.featured_image ? this.variants.currentVariant.featured_image.position : _.toInteger($(this.selectors.dataJs).attr('data-vrimgpos'));
      var imgsPos = [];
      _.forEach(imgspr, function(value,idx0) {
        if(_.toInteger(value) >= imgPos){
          imgsPos.push(_.toInteger(value));
          imgsPos.push(_.toInteger(imgspr[idx0+1]));
          return false;
        }
      });
      if(dataJs.vrsvideo !== '""' && dataJs.vrsvideo !== "undefined"){
        var vrsVideoArr = [];
        _.forEach(_.words(dataJs.vrsvideo, /[^, ]+/g), function(value, idx) {
          var item = new Object();
          item['position'] = value.split(':')[0];
          item['thumb'] = value.split('|http')[0].split(':')[2];
          item['url'] =  value.split('|http')[1].split(':')[1];
          vrsVideoArr.push(item)
        });
      }
      var vrvideo = _.find(vrsVideoArr, function(o) { return o.position == imgsPos[0] });
      if(vrvideo !== undefined){
        $('.pe-7s-play.kt_openvd_'+this.productSingleObject.id).removeClass('hidden');
        if((vrvideo.url).indexOf('.mp4') !== -1){
          $('.pe-7s-play.kt_openvd_'+this.productSingleObject.id)
          .magnificPopup({
            items: [
              {
                src: '<div class="white-popup"><div class="white-popupcontent"><video class="amp-page amp-video-element" id="myVideo_product" controls="controls" autoplay><source type="video/mp4" src="'+vrvideo.url+'"></video></div></div>',
                type: 'inline'
              }
            ],
            type: 'image'
          });
        }else if((vrvideo.url).indexOf('youtube.com') !== -1 || (vrvideo.url).indexOf('vimeo.com') !== -1){
          $('.pe-7s-play.kt_openvd_'+this.productSingleObject.id)
          .magnificPopup({
            items: [
              {
                src: vrvideo.url,
                type: 'iframe'
              }
            ],
            type: 'image'
          });
        }
      }else{
        $('.pe-7s-play.kt_openvd_'+this.productSingleObject.id).addClass('hidden');
      }
    },

    _create360: function(variant) {
      var dataJs = this.dataJs
          self = this;
      // Check 360 available
      var imgsPos360 = _.words(dataJs.imgspos360, /[^, ]+/g), primgs = _.words(dataJs.primgs, /[^, ]+/g), imgsprw = _.words(dataJs.primgswidth, /[^, ]+/g), imgsprh = _.words(dataJs.primgsheight, /[^, ]+/g);
      if(imgsPos360 !== '""' && imgsPos360 !== "undefined" && imgsPos360.length > 0){
        var files = [];
        _.forEach(primgs, function(value, idx) {
          if(_.toInteger(imgsPos360[0]) <= idx+1 && idx+1 < _.toInteger(imgsPos360[1])){
            var file = _.replace(dataJs.imgurl, 'kiti', value);
            files.push(file)
          }
        });
        theme.clickProductPopup.imgs360(files,imgsPos360,imgsprw[imgsPos360[0]],imgsprh[imgsPos360[0]],this.productSingleObject.id)
        $('.pe-360-degrees.kt_open_'+this.productSingleObject.id).removeClass('hidden')
      }
      if(self.settings.sectionId == 'quickview-template'){
        $(document).on('click','#myModal button.close', function () {
          $('.myModalThreeSixty.kt_'+self.productSingleObject.id).modal('hide').remove();
          $('#sizeGuide_and_shipping').remove();
        });
        $('#myModal').on('hidden.bs.modal', function () {
          $('.myModalThreeSixty.kt_'+self.productSingleObject.id).modal('hide').remove();
          $('#sizeGuide_and_shipping').remove();
        })
      }
    },

    _updatePrice: function(evt) {
      var variant = evt.variant;
      var template = '#' + $(this.selectors.productPhotoImages).parents("div.product-page").attr('id');
      $(this.selectors.variesPrice.replace('#','.')).addClass('hidden');
      // Update the product price
      $(this.selectors.originalPrice).html(theme.Currency.formatMoney(variant.price, theme.moneyFormat));
      $(this.selectors.originalPrice.replace('#','.')).removeClass('hidden').html(theme.Currency.formatMoney(variant.price, theme.moneyFormat));
      // Update and show the product's compare price if necessary
      if (variant.compare_at_price > variant.price) {
        $(this.selectors.comparePrice)
          .html(theme.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat))
          .removeClass('hidden');
        $(this.selectors.comparePrice.replace('#','.'))
          .html(theme.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat))
          .removeClass('hidden');
        $(this.selectors.originalPriceWrapper).addClass(this.selectors.saleClasses);
        $(this.selectors.saleLabel).removeClass('hidden');
      } else {
        $(this.selectors.comparePrice).addClass('hidden');
        $(this.selectors.comparePrice.replace('#','.')).addClass('hidden');
        $(this.selectors.saleLabel).addClass('hidden');
        $(this.selectors.originalPriceWrapper).removeClass(this.selectors.saleClasses);
      }
      if(theme.function.multiCurrency == true && cookieCurrency !== null && cookieCurrency !== shopCurrency){
        Currency.convertAll(shopCurrency,cookieCurrency,template+' .entry-summary span.money');
      }
    },

    _updateSKU: function(evt) {
      var variant = evt.variant;

      // Update the sku
      $(this.selectors.SKU).html(variant.sku);
    },

    onUnload: function() {
      this.$container.off(this.settings.namespace);
    }
  });

  return Product;
})();

theme.slideshows = {};
theme.SlideshowSection = (function() {
  function SlideshowSection(container) {
    var $container = this.$container = $(container);
    var sectionId = $container.attr('data-section-id');
    var slideshow = this.slideshow = '#Slideshow-' + sectionId;

    $('.slideshow__video', slideshow).each(function() {
      var $el = $(this);
      theme.SlideshowVideo.init($el);
      theme.SlideshowVideo.loadVideo($el.attr('id'));
    });

    theme.slideshows[slideshow] = new theme.Slideshow(slideshow);
  }

  return SlideshowSection;
})();

theme.SlideshowSection.prototype = _.assignIn({}, theme.SlideshowSection.prototype, {
  onUnload: function() {
    delete theme.slideshows[this.slideshow];
  },

  onBlockSelect: function(evt) {
    var $slideshow = $(this.slideshow);

    // Ignore the cloned version
    var $slide = $('.slideshow__slide--' + evt.detail.blockId + ':not(.slick-cloned)');
    var slideIndex = $slide.data('slick-index');

    // Go to selected slide, pause autoplay
    $slideshow.slick('slickGoTo', slideIndex).slick('slickPause');
  },

  onBlockDeselect: function() {
    // Resume autoplay
    $(this.slideshow).slick('slickPlay');
  }
});

window.theme = theme || {};
theme.Carousel = (function() {
  /* ---------------------------------------------
   Owl carousel
   --------------------------------------------- */
   function init(container) {
    var $container = this.$container = $(container);
    var sectionId = $container.attr('data-section-id');
    var carousel = this.carousel = '#Carousel-' + sectionId;
    $('#shopify-section-'+sectionId+' .owl-carousel').not('.kt-carousel').each(function() {
      var config = $(this).data();
      var navText = $(this).data('nav-text');
      var animateOut = $(this).data('animateout');
      var animateIn = $(this).data('animatein');
      if(typeof animateOut != 'undefined' ){
        config.animateOut = animateOut;
      }
      if(typeof animateIn != 'undefined' ){
        config.animateIn = animateIn;
      }
      if(typeof (navText) != 'undefined' ){
        config.navText = ['prev','next'];
      }
      config.lazyLoad = true;
      config.navElement = 'div';
      var owl = $(this);
      if(owl.hasClass('testimonial-owl')){
        config.navText = ['<i class="fa fa-angle-left"></i>','<i class="fa fa-angle-right"></i>'];
      }
      $('.kt_home_slide .item__').css({'float':'none','width':'auto'});
      owl.on('initialized.owl.carousel', function(event) {
        $('.carouselLoading').not('.kt-carousel').removeClass('carouselLoading');
      });
      owl.owlCarousel(config);
            
      if(owl.hasClass('testimonial-owl')){
        owl.trigger('next.owl.carousel');
      }
      owl.on('changed.owl.carousel', function(event) {
        if(owl.hasClass('testimonial-owl')){
          owl.find('.owl-item.active').removeClass('item-center');
          var caption = owl.find('.owl-item.active').first().next().find('.inner').html();

          var t = owl.closest('.testimonials-owl-3').find('.testimonial-info');
          var animated = t.data('animated');
          t.html(caption).addClass('animated '+animated).one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
            $(this).removeClass('animated '+animated);
          });
          setTimeout(function(){
            owl.find('.owl-item.active').first().next().addClass('item-center');
          }, 100);
        }
      })
    });
   }
  /* ---------------------------------------------
   Owl carousel mobile
   --------------------------------------------- */
  function initCarouselMobile(){
    var window_size = jQuery('body').innerWidth();
    window_size += theme.getScrollbarWidth();
    if( window_size < 768 ){
      $('.owl-carousel-mobile').each(function(){
        $(this).addClass('owl-carousel')
        var config = $(this).data();
        var animateOut = $(this).data('animateout');
        var animateIn = $(this).data('animatein');
        if(typeof animateOut != 'undefined' ){
          config.animateOut = animateOut;
        }
        if(typeof animateIn != 'undefined' ){
          config.animateIn = animateIn;
        }
        config.navElement = 'div';
        var owl = $(this);
        owl.owlCarousel(config);
      });
    }else{
      $('.owl-carousel-mobile').each(function(){
        var owl = $(this);
        owl.trigger('destroy.owl.carousel').removeClass('owl-carousel owl-loaded');
        owl.find('.owl-stage-outer').children().unwrap();
      })
    }
  }
  return{
    init: init,
    initCarouselMobile: initCarouselMobile
  };
})();

window.theme = window.theme || {};
theme.CarouselSection = (function() {
  function Carousel(container) {
    var $container = this.$container = $(container);
    theme.Carousel.init(container);
    theme.Carousel.initCarouselMobile(container);
  }
  return Carousel;
})();

window.theme = theme || {};
theme.TabOwlFadeEffect = (function() {
  // effect first tab
  var sleep = 0;
  $('.tab-owl-fade-effect .nav-tab>li.active a[data-toggle="tab"]').each(function(){
    var tabElement = $(this);
    setTimeout(function() {
      tabElement.trigger('click');
    }, sleep);
    sleep += 10000
  })
  // effect click
  $(document).on('click','.tab-owl-fade-effect a[data-toggle="tab"]',function(){
    var tab_id = $(this).attr('href');
    var tab_animated = $(this).data('animated');
    tab_animated = ( tab_animated == undefined || tab_animated =="" ) ? 'fadeInUp' : tab_animated;
    $(tab_id).find('.owl-item.active').each(function(i){
      var t = $(this);
      var style = t.attr("style");
      style = ( style == undefined ) ? '' : style;
      var delay  = i * 400;
      t.attr("style", style +
             ";-webkit-animation-delay:" + delay + "ms;"
             + "-moz-animation-delay:" + delay + "ms;"
             + "-o-animation-delay:" + delay + "ms;"
             + "animation-delay:" + delay + "ms;"
            ).addClass(tab_animated+' animated').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
        t.removeClass(tab_animated+' animated');
        t.attr("style", style);
      });
    })
  })
});
  
window.theme = theme || {};
theme.TabProductFadeEffect = (function() {
  // effect first tab
  var sleep = 0;
  $('.tab-product-fade-effect .nav-tab>li.active a[data-toggle="tab"]').each(function(){
    var tabElement = $(this);
    setTimeout(function() {
      tabElement.trigger('click');
    }, sleep);
    sleep += 10000
  })
  // effect click
  $(document).on('click','.tab-product-fade-effect a[data-toggle="tab"]',function(){
    var tab_id = $(this).attr('href');
    var tab_animated = $(this).data('animated');
    tab_animated = ( tab_animated == undefined || tab_animated =="" ) ? 'fadeInUp' : tab_animated;
    $(tab_id).find('.grid-item').each(function(y){
      var t = $(this);
      var style = t.attr("style");
      style = ( style == undefined ) ? '' : style;
      var delay  = y * 400;
      t.attr("style", style +
             ";-webkit-animation-delay:" + delay + "ms;"
             + "-moz-animation-delay:" + delay + "ms;"
             + "-o-animation-delay:" + delay + "ms;"
             + "animation-delay:" + delay + "ms;"
            ).addClass(tab_animated+' animated').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
        t.removeClass(tab_animated+' animated');
        t.attr("style", style);
      });
    })
  })
});

window.theme = theme || {};
theme.ProductsMasorySection = (function() {  
  function MasorySection(container) {
    var $container = this.$container = $(container);
    var sectionId = $container.attr('data-section-id');
    var masory = this.masonry = '#Masory-' + sectionId;
    var $grid = $(masory+ '.ly__ms_items').isotope({
      itemSelector: '.grid-item',
      masonry: {
        horizontalOrder: true,
        percentPosition: true
      },
      transitionDuration: '.8s'
    });
    $grid.imagesLoaded().progress( function() {
      $grid.isotope('layout');      
      theme.checkProductGrid_Width();
    });
  }
  return MasorySection;
})();

window.theme = theme || {};
theme.ContentMasorySection = (function() {  
  function MasorySection(container) {
    var $container = this.$container = $(container);
    var sectionId = $container.attr('data-section-id');
    var masory = this.masonry = '#MasoryBlock-' + sectionId;
    var $grid = $(masory+ ' .block_masonry').isotope({
      itemSelector: '.block-kt-banner',
      layoutMode: 'packery',
      masonry: {
        horizontalOrder: true,
        percentPosition: true
      },
      transitionDuration: '.8s'
    });
  }
  return MasorySection;
})();

window.theme = theme || {};
theme.BannerByPage = (function() {  
  function BannerSection(container) {
    var $container = this.$container = $(container);
    var sectionId = $container.attr('data-section-id');
    
    // headerBannerByPage
    var headerBBP = '';
    var sectionBanner = $('div[data-section-id="'+sectionId+'"]')
    var bannerCrr = sectionBanner.attr('data-collection');
    if(headerBanner !== undefined && headerBanner !== null){
      _.forEach(headerBanner, function(block,idx0) {
        var headerBBPItem = "";
        if(block.settings.image_1 == null && block.settings.image_2 == null && block.settings.image_3 == null){
          sectionBanner.slideUp('slow');
        }
        else{
          if(block.settings.use_parallax ==  false){
          headerBBPItem += '<div class="';
          if(block.settings.width_section == true){
            headerBBPItem += 'container';
          }
          headerBBPItem += '">';
          }
          if(block.type == 'collection_banner'){
            var listHandle = _.split(block.settings.by_collections_11, ',');
          }
          else if(block.type == 'product_banner'){
            var listHandle = _.split(block.settings.by_product_11, ',');
          }
          else if(block.type == 'blog_banner'){
            var listHandle = _.split(block.settings.by_blog_11, ',');
          }
          else if(block.type == 'article_banner'){
            var listHandle = _.split(block.settings.by_article_11, ',');
          }
          else if(block.type == 'page_banner'){
            var listHandle = _.split(block.settings.by_page_11, ',');
          }
          _.find(block.settings, function(itemCll,itemName) {
            if(page.Han == itemCll && bannerCrr !== itemCll || _.indexOf(listHandle,page.Han) >= 0 && listHandle.length > 0 && itemName == 'by_collections_11' && bannerCrr !== itemCll){
              var imgCount = 0;
              if(block.settings.image_1 != null){imgCount++}
              if(block.settings.image_2 != null){imgCount++}
              if(block.settings.image_3 != null){imgCount++}
              var data_loop = imgCount == 1 ? 'false' : 'true';
              headerBBPItem += '<div class="shop-banner" style="margin-bottom:'+block.settings.margin_bt+'px">';
              if(block.settings.use_parallax){
                headerBBPItem += '<div class="parallax-section page-banner bg-parallax" style="background-image: url('+block.settings.image_1+')" data-parallax-speed="0.1">';
                  headerBBPItem += '<div class="parallax_page_content" style="padding:'+block.settings.parallax_padding+'">';
                    headerBBPItem += '<div class="container">';
                      headerBBPItem += '<div class="banner-content text-center"> <span class="subtitle">'+block.settings.text_parallax+'</span>';
                        headerBBPItem += '<h2 class="title">'+block.settings.title_parallax+'</h2>';
                      headerBBPItem += '</div>';
                    headerBBPItem += '</div>';
                  headerBBPItem += '</div>';
                  headerBBPItem += '<div class="overlay"></div>';
                headerBBPItem += '</div>';
              }
              else{
                headerBBPItem += '<div class="kt-carousel nav-center-center nav-style7 carouselLoading" data-autoplay="true" data-loop="'+data_loop+'" data-items="1" data-dots="false" data-nav="true" data-auto-height="true" data-animateout="fadeOut" data-animatein="fadeIn">';
                if(block.settings.image_1 != null){
                  headerBBPItem += '<img class="grid-view-item__image key_image lazyload" src="'+(block.settings.image_1).replace('.jpg?','_50x.jpg?')+'" data-src="'+block.settings.image_1+'" alt="">';
                }
                if(block.settings.image_2 != null){
                  headerBBPItem += '<img class="grid-view-item__image lazyload" src="'+(block.settings.image_2).replace('.jpg?','_50x.jpg?')+'" data-src="'+block.settings.image_2+'" alt="">';
                }
                if(block.settings.image_3 != null){
                  headerBBPItem += '<img class="grid-view-item__image lazyload" src="'+(block.settings.image_3).replace('.jpg?','_50x.jpg?')+'" data-src="'+block.settings.image_3+'" alt="">';
                }
                headerBBPItem += '</div>';
              }
              headerBBPItem += '</div>';
              if(sectionBanner.hasClass('default')){
                sectionBanner.removeClass('default').attr('data-collection',itemCll);
              }
              // console.log(block.settings)
            }
            else if(page.Han == itemCll && bannerCrr === itemCll || _.indexOf(listHandle,page.Han) >= 0 && listHandle.length > 0 && itemName == 'by_collections_11' && bannerCrr === itemCll){
              headerBBP = 'showing';
            }
          });
          if(block.settings.use_parallax ==  false){
          headerBBPItem += '</div>';
          }
        }
        if(headerBBPItem.indexOf('//cdn.') !== -1){
          headerBBP += headerBBPItem;
        }
      });
      if(headerBBP === 'showing'){
        sectionBanner.slideDown('slow');
        sectionBanner.find('img').css('opacity',1)
      }
      else if(headerBBP !== ''){
        var headerBBPowl = sectionBanner;
        headerBBPowl.html(headerBBP).slideDown('slow',function(){
          if(headerBBPowl.find('img').length > 1){
            headerBBPowl.find('.carouselLoading').addClass('owl-carousel');
            var config = headerBBPowl.find('.kt-carousel').data();
            headerBBPowl.find('.kt-carousel').on('initialized.owl.carousel', function(event) {
              headerBBPowl.find('.carouselLoading').removeClass('carouselLoading');
            });
            sectionBanner.find('img.key_image').imagesLoaded().done( function() {
              headerBBPowl.find('.kt-carousel').owlCarousel(config);
            });
          }
          else{
            sectionBanner.find('img.key_image').imagesLoaded().done( function() {
              kt_parallax();
            });
          }
        });
        sectionBanner.addClass('default');
      }
      else{
        sectionBanner.slideUp('slow');
      }
    }
  }
  return BannerSection;
})();

window.theme = theme || {};
theme.BannerMasorySection = (function() {  
  function MasorySection(container) {
    var $container = this.$container = $(container);
    var sectionId = $container.attr('data-section-id');
    var $grid = $('#shopify-section-'+sectionId+' .banner_masonry').isotope({
      itemSelector: '.banner--grid-item',layoutMode: 'packery',
      masonry: {
        horizontalOrder: true,
        percentPosition: true
      },
      transitionDuration: '.8s'
    });
    $grid.imagesLoaded().progress( function() {
      $grid.isotope('layout');
    });
  }
  function carouselBanner(container) {
    var $container = this.$container = $(container);
    var sectionId = $container.attr('data-section-id');
    $('#shopify-section-'+sectionId+' .owl-carousel').each(function() {
      var config = $(this).data();
      var navText = $(this).data('nav-text');
      var animateOut = $(this).data('animateout');
      var animateIn = $(this).data('animatein');
      if(typeof animateOut != 'undefined' ){
        config.animateOut = animateOut;
      }
      if(typeof animateIn != 'undefined' ){
        config.animateIn = animateIn;
      }
      if(typeof (navText) != 'undefined' ){
        config.navText = ['prev','next'];
      }
      config.lazyLoad = true;
      var owl = $(this);
      owl.on('initialized.owl.carousel', function(event) {
        $('.carouselLoading').not('.kt-carousel').removeClass('carouselLoading');
      });
      owl.owlCarousel(config);
    });
  }
  return{
    MasorySection:MasorySection,
    carouselBanner: carouselBanner
  }
})();

window.theme = theme || {};
theme.Instagram = (function() {  
  function Instagram(container) {
    var $container = this.$container = $(container);
    var sectionId = $container.attr('data-section-id');
    $('#shopify-section-'+sectionId+' .instagramWrapper').each(function() {
      var ul_ins = $(this),
        user_name = ul_ins.data('username'),
        limit = ul_ins.data('limit');
      if("" == user_name) return;
      $.ajax({
        url: 'https://api.teathemes.net/instagram?username='+user_name,
        dataType: 'json',
        type: 'GET',
        success: function(responsive) {
          // console.log(responsive.entry_data.ProfilePage[0].user.media.nodes);
          var html = '',
            img_url = null,
            data = responsive.entry_data.ProfilePage[0].user.media.nodes;
          $.each(data, function(index, element) {
            if(index >= limit) return 0;
            var img_url_150 = element.thumbnail_resources[0].src,
              img_url_240 = element.thumbnail_resources[1].src,
              img_url_320 = element.thumbnail_resources[2].src,
              img_url_480 = element.thumbnail_resources[3].src,
              img_url_640 = element.thumbnail_resources[4].src;
            html += '<a class="db pr oh banner-opacity" href="//instagram.com/p/' + element.code + '"><img src="' + img_url_150 + '" data-src="' + img_url_150 + '" data-sizes="auto" data-srcset="' + img_url_150 + ' 150w,' + img_url_240 + ' 240w,' + img_url_320 + ' 320w,' + img_url_480 + ' 480w,' + img_url_640 + ' 640w" class="w__100 lazyload img-responsive" alt="'+user_name+'"><div class="info pa text-center"><span class="pr cw mgr10"><i class="fa fa-heart-o mr__5"></i>' + element.likes.count + '</span><span class="pr cw"><i class="fa fa-comments-o mr__5"></i>' + element.comments.count + '</span></div></a>';
          });
          ul_ins.html(html);
        },
        error: function(data) {
          console.log('ajax error');
        },
        complete: function() {
          ul_ins.addClass('owl-carousel')
          var config = ul_ins.data();
          if(typeof animateOut != 'undefined' ){
            config.animateOut = animateOut;
          }
          if(typeof animateIn != 'undefined' ){
            config.animateIn = animateIn;
          }
          if(typeof (navText) != 'undefined' ){
            config.navText = ['prev','next'];
          }
          config.lazyLoad = true;
          config.navElement = 'div';
          var owl = ul_ins;
          owl.on('initialized.owl.carousel', function(event) {
            $('.carouselLoading').not('.kt-carousel').removeClass('carouselLoading');
          });
          owl.owlCarousel(config);
        }
      });
    });
  }
  return Instagram;
})();

window.theme = theme || {};
theme.lookBook = (function() { 
  function lookBook(container) {
    var $container = this.$container = $(container);
    var sectionId = $container.attr('data-section-id');
    if(product_handle !== null){
      $.ajax({
        url: '/products/'+product_handle+'?view=lookbook',
        type: 'GET',
        dataType: 'html'
      })
      .done(function(data) {
        // console.log("success");
        var dataJs = $.parseJSON(data.split('/kiti')[1]);
        _.forEach(dataJs, function(item) {
          if(item.id === product_handle){
            if($('[alt="'+item.handle+'"]').length){
              $('[alt="'+item.handle+'"]').each(function(){
                var self = $(this);
                var pin = '', parent_pin = self.parent();
                parent_pin.find('.kt_pins').length <= 0 ? parent_pin.append('<div class="kt_pins"></div>') : parent_pin.find('.kt_pins').html('');
                _.forEach([1, 2, 3, 4, 5], function(value) {
                  var top_pin = 'top_pin_' + value,
                      left_pin = 'left_pin_' + value,
                      size_ = 'size_' + value,
                      background = 'bg_' + value,
                      handle = 'id_' + value;
                  if(item[handle] !== ''){
                    var top = item[top_pin] - ((item[size_] / 2) / self.height() * 100), left = item[left_pin] - ((item[size_] / 2) / self.width() * 100) ;
                    pin += '<div class="button kt_pin" data-product-handle="'+item[handle]+'" style="top: '+ top +'%;left: '+ left +'%;width: '+item[size_]+'px;height: '+item[size_]+'px;line-height: '+item[size_]+'px; background-color: '+item[background]+'">';
                    pin += '<span class="kt_pin_name">+</span>';
                    pin += '</div>';
                    loadpr_lookBook(item[handle])
                  }
                });
                self.parent().addClass('kt_pin_item').find('.kt_pins').html(pin)
              });
            }
          }
        });
      })
      .fail(function() {
        console.log("error lookbook-product-single");
      })
      .always(function() {
        theme.clickProductPopup.init('.kt_pin a.quickshopMiniList');
      });
    }
  }
  function loadpr_lookBook(handle) {
    $.ajax({
      url: '/products/'+handle+'?view=miniListJs',
      type: 'GET',
      dataType: 'html'
    })
    .done(function(data) {
      var prJs = data;
      var info = '';
          info += '<div class="kt_pin_pritem">';
          info += data;
          info += '</div>';
      $('.kt_pin[data-product-handle="'+handle+'"]:not(.loaded)').addClass('loaded').append(info);
      theme.DropdownReposive.init('.kt_pins','.kt_pin','.kt_pin_pritem');
    });
  }
  return lookBook;
})();

theme.variantImage = (function(){
  $('.swatches-list.nomore .swatch-on-grid .swatch')
  .on('mouseenter',function(event){
    var front_image = $(this).closest('.product-inner').find('.front-image');
    front_image.css({'width':front_image.width()+'px','height':front_image.height()+'px'})
  })
  .on('click',function(event){
    event.preventDefault();
    var image = $(this).data().vrimg;
    var itemData = $(this).data();
    if(image != null && $(this).closest('.product-inner').find('.front-image img[data-srcset*="'+theme.Images.nameImage(image)+'_540x."]').length <= 0){
      var front_image = $(this).closest('.product-inner').find('.front-image');
      front_image.addClass('loading_vaimg');
      var fileExt = _.last(image.split('.')), img_url = _.replace(image, '.'+fileExt, '_{width}x.'+fileExt) ;
      var img = '<img class="lazyload" data-src="'+img_url+'" data-widths="[180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048]" data-sizes="auto" alt="'+$(this).data().vrtitle+'">';
      front_image.html(img)
      var images = front_image.find('img');
      var loadedImgNum = 0;
      images.on('load', function(){
        loadedImgNum += 1;
        if (loadedImgNum == images.length) {
          front_image.removeClass('loading_vaimg');
        }
      });
      setTimeout(function(){
        front_image.removeClass('loading_vaimg');
      },1000);
    }
    $(this).closest('.product-inner').find('.swatch-on-grid').removeClass('active');
    $(this).parent().addClass('active');
    $(this).closest('.product-inner').find('.kt__add-to-cart').attr('data-vrid',itemData.vrid);
    $(this).closest('.product-inner').find('.ProductPrice-'+ itemData.prid).html(theme.Currency.formatMoney(itemData.vrprice, theme.moneyFormat)).removeClass('hidden');
    $(this).closest('.product-inner').find('.ProductVaries-'+ itemData.prid).addClass('hidden');
    var pr_vrcompareprice = $(this).closest('.product-inner').find('.ComparePrice-'+ itemData.prid);
    var addToCart = $(this).closest('.product-inner').find('.kt__add-to-cart');
    if(itemData.vrpricec != null && itemData.vrpricec !== undefined && itemData.vrpricec > itemData.vrprice){
      pr_vrcompareprice.removeClass('hidden').html(theme.Currency.formatMoney(itemData.vrpricec, theme.moneyFormat));
    }
    else{
      if(pr_vrcompareprice.hasClass('hidden') === false){pr_vrcompareprice.addClass('hidden')}
    }
    if(itemData.available || itemData.available && itemData.ivqty <= 0 && itemData.intpolicy != 'deny'){
      if(itemData.ivqty <= 0 && itemData.intpolicy != 'deny'){
        addToCart.attr('disabled', false).text(theme.productStrings.preOrder);
      }else{
        addToCart.attr('disabled', false).text(theme.productStrings.addToCart);
      }
    }else{
      addToCart.prop('disabled', true).text(theme.productStrings.soldOut);
    }
  })
})

theme.menuBgChange = (function(){
  $(document).on('mouseenter','a.bgChange',function(event){
    event.preventDefault();
    var image = $(this).attr('data-hover-image');
    var content = $(this).attr('data-hover-banner');
    if(image !== undefined || content !== undefined ){
      $(this).parents('.sub-menu.megamenu').addClass('hiddenBg');    
      if($(this).parents('.sub-menu.megamenu').find('.imgByCollection').length == 0){
        if(image !== undefined){
          $(this).parents('.sub-menu.megamenu').append('<img class="imgByCollection" src="'+image+'" >');
        }else{
          $('.imgByCollection').remove();
          $(this).parents('.sub-menu.megamenu').append(content);
        }
      }else{
        $('.sub-menu.megamenu a.img-cate').remove();
        if(image !== undefined){
          $('.imgByCollection').show();
          $(this).parents('.sub-menu.megamenu').find('.imgByCollection').attr('src',image);
        }else{
          $('.imgByCollection').hide();
          $(this).parents('.sub-menu.megamenu').append(content);
        }
      }
    }
  })
  .on('mouseleave','a.bgChange',function(event){
    $(this).parents('.sub-menu.megamenu').removeClass('hiddenBg');
    $('.imgByCollection').hide();
    $('.sub-menu.megamenu a.img-cate').hide();
  });
});

theme.checkProductGrid_Width = (function(){
  $('.quickshopForm').each(function(){
    var parentHeight = $(this).parents('.product-item').find('.product-thumb').height();
    $(this).parents('.product-item').addClass('normalQuickshop');
    $(this).css('max-height',parentHeight);
  });
  $('.grid-item .product-item, .product-card-small-list').each(function(){
    var parentWidth = $(this).width();
    if(parentWidth < 230){
      $(this).addClass('smallCard').removeClass('normalCard');
    }
    else{
      $(this).addClass('normalCard').removeClass('smallCard');
    }
  });
});

theme.Quantity = (function(){  
  $('.quantity-inner').each(function() {
    if($(this).hasClass('checked') == false){      
      var spinner = $(this),
          input = spinner.find('input[type="number"]'),
          btnUp = spinner.find('.quantity-up'),
          btnDown = spinner.find('.quantity-down'),
          min = input.attr('min'),
          max = input.attr('max');

      btnUp.click(function() {
        var oldValue = parseFloat(input.val());
        if (oldValue >= max) {
          var newVal = oldValue;
        } else {
          var newVal = oldValue + 1;
        }
        spinner.find("input").val(newVal);
        spinner.find("input").trigger("change");
      });

      btnDown.click(function() {
        var oldValue = parseFloat(input.val());
        if (oldValue <= min) {
          var newVal = oldValue;
        } else {
          var newVal = oldValue - 1;
        }
        spinner.find("input").val(newVal);
        spinner.find("input").trigger("change");
      });

      input.on('change',function(event) {
        if(input.val() == 0){
          input.val(1)
        }
      });
    spinner.addClass('checked');
    }
  });
});

theme.initPhotoSwipeFromDOM = (function(gallerySelector, elcloned, tgName, callback){
    // loop through all gallery elements and bind events
    var galleryElements = $( gallerySelector );
    // parse slide data (url, title, size ...) from DOM elements 
    // (children of gallerySelector)
    var parseThumbnailElements = function(el) {
      // build items array
      var itemsArray = $(el).find(elcloned+' [data-size]');
      var items = [];
      _.forEach(itemsArray, function(elItem, idx) {
        var item = new Object();
        item['src'] = $(elItem).attr('data-srcfix');
        item['w'] = $(elItem).attr('data-size').split('x')[0];
        item['h'] = $(elItem).attr('data-size').split('x')[1];
        items.push(item)
      });
      return items;
    };

    // find nearest parent element
    var closest = function closest(el, fn) {
      return el && ( fn(el) ? el : closest(el.parentNode, fn) );
    };

    // triggers when user clicks on thumbnail
    var onThumbnailsClick = function(e) {
      e = e || window.event;
      e.preventDefault ? e.preventDefault() : e.returnValue = false;

      var eTarget = e.target || e.srcElement;

      // find root element of slide
      var clickedListItem = closest(eTarget, function(el) {
        return (el.tagName && el.tagName.toUpperCase() === tgName);
      });
      if(!clickedListItem) {
        return;
      }

      // find index of clicked item by looping through all child nodes
      // alternatively, you may define index via data- attribute
      var clickedGallery = $(clickedListItem).parents(gallerySelector),
          childNodes = clickedGallery.find(elcloned+' [data-size]'),
          numChildNodes = childNodes.length,
          nodeIndex = 0,
          index;
      for (var i = 0; i < numChildNodes; i++) {
        if(childNodes[i] === clickedListItem) {
          index = nodeIndex;
          break;
        }
        nodeIndex++;
      }
      if(index >= 0) {
        // open PhotoSwipe if valid index found
        openPhotoSwipe( index, clickedGallery );
      }
      return false;
    };

    var openPhotoSwipe = function(index, galleryElement, disableAnimation, fromURL) {
      var pswpElement = $('.pswp')[0],
          gallery,
          options,
          items;

      items = parseThumbnailElements(galleryElement);

      // define options (if needed)
      options = {
        // history & focus options are disabled
        history: false,
        focus: false,

        // define gallery index (for URL)
        galleryUID: $(galleryElement).attr('data-pswp-uid'),

        getThumbBoundsFn: function(index) {
          // See Options -> getThumbBoundsFn section of documentation for more info
          var thumbnail = $(galleryElement).find(elcloned+' [data-size]')[index], // find thumbnail
              pageYScroll = window.pageYOffset || document.documentElement.scrollTop,
              rect = thumbnail.getBoundingClientRect(); 

          return {x:rect.left, y:rect.top + pageYScroll, w:rect.width};
        },
        shareButtons: [
          {id:'facebook', label:'Share on Facebook', url:'https://www.facebook.com/sharer/sharer.php?u={{url}}'},
          {id:'twitter', label:'Tweet', url:'https://twitter.com/intent/tweet?text={{text}}&url={{url}}'},
          {id:'pinterest', label:'Pin it', url:'http://www.pinterest.com/pin/create/button/?url={{url}}&media={{image_url}}&description={{text}}'}
        ]

      };

      // PhotoSwipe opened from URL
      if(fromURL) {
        if(options.galleryPIDs) {
          // parse real index when custom PIDs are used 
          // http://photoswipe.com/documentation/faq.html#custom-pid-in-url
          for(var j = 0; j < items.length; j++) {
            if(items[j].pid == index) {
              options.index = j;
              break;
            }
          }
        } else {
          // in URL indexes start from 1
          options.index = parseInt(index, 10) - 1;
        }
      } else {
        options.index = parseInt(index, 10);
      }

      // exit if index not found
      if( isNaN(options.index) ) {
        return;
      }

      if(disableAnimation) {
        options.showAnimationDuration = 0;
      }
      
      // Pass data to PhotoSwipe and initialize it
      gallery = new PhotoSwipe( pswpElement, PhotoSwipeUI_Default, items, options);
      gallery.init();
      gallery.listen('afterChange', function() {
        callback(gallery.getCurrentIndex(),gallery.currItem)
      });
    };

    for(var i = 0, l = galleryElements.length; i < l; i++) {
      galleryElements[i].setAttribute('data-pswp-uid', i+1);
      galleryElements[i].onclick = onThumbnailsClick;
    }
})

theme.scrollbarVariantGridProduct = (function(){
  $('.grid-item .product-info .swatches-list:not(.circle_big) .attributesScroll').each(function(){
    $(this).mCustomScrollbar({
      axis:"x",
      theme:"dark-thin",
      autoExpandScrollbar:false,
      autoHideScrollbar:true,
      scrollbarPosition: "outside",
      scrollInertia: 400,
      advanced:{autoExpandHorizontalScroll:true}
    });
  });
})

theme.variantCheckStyle = (function(){
  $('.swatches-list').each(function(){
    if($(this).data().swatchesstyle == 'image_variant' && $(this).data().usecolor == true){
      if($(this).parents('.product-inner').find('.swatchesJson').length !== 0){
        var elJs = $(this).parents('.attributes');
        var dataVRSjson = JSON.parse(elJs.find('#ProductJson')[0].innerHTML);

        $(this).find('.swatch').each(function(){
          var dataJs = $(this).data();
          var vrjson = _.find(dataVRSjson.variants, function(o) { return o.id == dataJs.vrid });
          if(vrjson.featured_image !== null){
            var imgBg = Shopify.KT_resizeImage(vrjson.featured_image.src,"100x100");
            $(this).addClass('lazyload').attr('data-bgset',imgBg).attr('data-sizes','auto').attr('data-parent-fit','cover');
          }
        });
      }else{
        $(this).find('.swatch').each(function(){
          var dataJs = $(this).data();
          if(dataJs.vrimg !== null){
            var imgBg = Shopify.KT_resizeImage(dataJs.vrimg,"100x100");
            $(this).addClass('lazyload').attr('data-bgset',imgBg).attr('data-sizes','auto').attr('data-parent-fit','cover');
          }
        });
      }
    }
  });
})

theme.floatingAddToCart = (function(container){
  var kt__addToCart = container == undefined ? $('.kt__add-to-cart') : $(container + ' .kt__add-to-cart'),
      positionCartCheck = function(){
        var cartVisible = new Object();
        $('.positionCart').each(function(){
          if(this.getBoundingClientRect().top > 1){
            cartVisible = $(this).offset();
            return false;
          }
        });
        return cartVisible;
      };
  kt__addToCart.click(function(){
    if($(this).prop('disabled') || $(this).attr('onclick') !== undefined){
      return false;
    }
    // add on grid
    var img = $(this).closest('.product-inner').find(".front-image img"),
        position = img.parents('.thumb-inner'),
        positionCart = positionCartCheck(),
        classAttr = img.length ? img.parent().attr('class').replace('quickshopMobile ','') : '';
    if(positionCart.left == undefined || img.length <= 0 && $(container).length <= 0){
      var qty = 1;
      if($(this).closest('.product-inner').find('#vr-'+$(this).attr('data-vrid')).length){
        qty = $(this).closest('.product-inner').find('#vr-'+$(this).attr('data-vrid')).val();
      }
      Shopify.KT_addItem($(this).attr('data-vrid'),1);$(this).addClass('loading').removeClass('loaded');
    } else {    
      // add on quickshop
      if($(container).length){
        if($(window).width() <= 768 && $('.closeQuickShop').length){
          $('.closeQuickShop').trigger('click');
        }
        img = $(this).closest('.product-inner').find(".owl-item.active img").first();
        position = img.parents(".kt_QuickShopslide");
        positionCart = positionCartCheck(),
          classAttr = '';
      }
      $("body").append('<div class="floating-cart '+classAttr+'"></div>');
      var cartFloating = $('div.floating-cart');    
      cartFloating
      .html(img[0].outerHTML)
      .show()
      .addClass('animated fadeIn')
      .css({'top' : position.offset().top + 'px', 'left' : position.offset().left + 'px', 'width' : position.width(), 'height' : position.height()})
      .animate({'top' : (positionCart.top - 50) + 'px', 'left' : (positionCart.left - 12.5) + 'px', 'width' : '50px', 'height' : '50px'});
      var qty = 1;
      if($(this).closest('.product-inner').find('#vr-'+$(this).attr('data-vrid')).length){
        qty = $(this).closest('.product-inner').find('#vr-'+$(this).attr('data-vrid')).val();
      }
      Shopify.KT_addItem($(this).attr('data-vrid'),qty)
      setTimeout(function(){
        cartFloating.removeClass('fadeIn').addClass('cartAdding bounce');
      }, 1000);
    }
  });
})

theme.stockCountdown = (function(container){
  if($(container).length <= 0){return false}    
  // Settings are here
  var total_items = 70;
  var check_stock = false;
  var timer = null,timerinterval = null;
  var min_of_remaining_items = 1;
  var decrease_after = 1.7; 
  var decrease_after_first_item = 0.17; 
  var min_items_left = parseInt($(container).attr('data-stock-from'));
  var max_items_left = parseInt($(container).attr('data-stock-to'));
  var remaining_items = parseInt($(container).attr('data-remaining_items')) || randomIntFromInterval(min_items_left, max_items_left);
  var stock_bg_process = $(container).attr('data-stock-bg-process');
  function randomIntFromInterval(min, max) {return Math.floor(Math.random() * (max - min + 1) + min);}
  function progressbar(container,remaining_items) {
    $(container).html('');
    var $this = $(container),content = '<p>'+theme.productStrings.stockMessage[0]+' <span class="count">' + remaining_items + '</span> '+theme.productStrings.stockMessage[1]+'</p><div class="progressbar"><div style="width:100%"></div></div>';
    $this.addClass('items-count');
    $this.html(content);
    updateMeter($this,remaining_items);
    timer = setTimeout(function() {
      remaining_items--;
      if(remaining_items < min_of_remaining_items) {
        remaining_items = randomIntFromInterval(min_items_left, max_items_left)
      }
      $this.find('.count').css('background-color', stock_bg_process);
      $this.find('.count').css('color', '#fff');
      setTimeout(function() {
        $this.find('.count').css('background-color', '#fff');
        $this.find('.count').css('color', stock_bg_process)
      },1000 * 60 * 0.03);
      $this.find(".count").text(remaining_items);
      $(container).closest('.product-inner').find('.show-iq span,#quantity_sticky span').text(remaining_items);
      updateMeter(container,remaining_items)
    }, 1000 * 60 * decrease_after_first_item );

    timerinterval = setInterval(function() {
      remaining_items--;
      if (remaining_items < min_of_remaining_items) {
        remaining_items = randomIntFromInterval(min_items_left, max_items_left)
      }
      $(container).find('kt_progress_bar_pr .count').css('background-color', stock_bg_process);
      $(container).find('kt_progress_bar_pr .count').css('color', '#fff');
      setTimeout(function() {
        $(container).find('kt_progress_bar_pr .count').css('background-color', '#fff');
        $(container).find('kt_progress_bar_pr .count').css('color', stock_bg_process)
      }, 1000 * 60 * 0.03);
      $this.find(".count").text(remaining_items);
      $(container).closest('.product-inner').find('.show-iq span,#quantity_sticky span').text(remaining_items);
      updateMeter(container,remaining_items)
    }, 1000 * 60 * decrease_after)
  }
  function updateMeter(container,remaining_items) {
    var width = 100 * remaining_items / total_items;
    if (remaining_items < 10) {
      $(container).find('.progressbar div:first').addClass('less-than-ten')
    }
    $(container).find('.progressbar').addClass('active progress-striped');
    setTimeout(function() {
      $(container).find('.progressbar div:first').css('width', width + '%');
      $(container).find('.progressbar').removeClass('active progress-striped')
    },300);
  }
  return progressbar(container,remaining_items);
})

theme.variantChange = (function(container){
  var kt__attributes = container == undefined ? $('.attributes .item span') : $(container + ' .attributes .item span');
  kt__attributes.click(function(){
    if($(this).parent().hasClass('active')){ return false; }
    var dataJs = $(this).data();
    var elJs = $(this).parents('.attributes');
    var $thisJs = $(this);    
    var imgsPos = $(this).closest('.product-inner').find('.datajs').attr('data-imgspos');
    var vrsVideo = $(this).closest('.product-inner').find('.datajs').attr('data-vrsvideo');
    var optChange = {
      setChange : function(itemData, itemOpt){
        var itemOpt = elJs.find(itemOpt);
        if(itemOpt.length > 0){
          itemOpt.find('li').each(function(){ $(this).hide().removeClass('active') });
          itemOpt.find('.'+itemData.vrs).show().first().addClass('active');
          itemOpt.find('.'+itemData.vrs).last().addClass('last');
          return itemOpt.find('span[data-vrid='+itemData.vrid+']').data();
        }
      },
      vrChange : function(itemData){
        $thisJs.parents('.swatches-list').find(".active").removeClass('active');
        $thisJs.parent().addClass('active');
        var vrprice = itemData.vrprice, vrpricec = itemData.vrpricec, vrimg = itemData.vrimg, ratio = itemData.ratio, vrtitle = itemData.vrtitle, vravailable = itemData.available, inventory_quantity = itemData.ivtqty, inventory_policy = itemData.ivtpolicy;
        if(elJs.find('.swatchesJson').length !== 0){
          var dataPjson = JSON.parse(elJs.find('#ProductJson')[0].innerHTML);
          var vrjson = _.find(dataPjson.variants, function(o) { return o.id == itemData.vrid });
          vrprice = vrjson.price;
          vrpricec = vrjson.compare_at_price;
          vrimg = vrjson.featured_image !== null ? vrjson.featured_image.src : null;
          ratio = vrjson.featured_image !== null ? vrjson.featured_image.width / vrjson.featured_image.height : null;
          vrtitle = vrjson.name;
          vravailable = vrjson.available;
          inventory_quantity = vrjson.inventory_quantity;
          inventory_policy = vrjson.inventory_policy
        }
        if(itemData.opts > 1){
          if(vrjson.featured_image !== null && theme.function.vrsgallery && $('.kt_product-images').length !== 0){
            var vrsVideo = $thisJs.closest('.product-inner').attr('data-vrsvideo');
            var imgPos = vrjson.featured_image.position;
            var imgsPos = $thisJs.closest('.product-inner').attr('data-imgspos');
            var imgspr = _.words(imgsPos, /[^, ]+/g), imgs = '';
            if(imgsPos !== '""' && imgsPos !== undefined && _.indexOf(imgspr,_.toString(imgPos)) !== -1){
              var imgsPos = [];
              _.forEach(imgspr, function(value,idx0) {
                if(_.toInteger(value) >= imgPos){
                  imgsPos.push(_.toInteger(value));
                  imgsPos.push(_.toInteger(imgspr[idx0+1]));
                  return false;
                }
              });              
              if(vrsVideo !== '""' && vrsVideo !== "undefined"){
                var vrsVideoArr = [];
                _.forEach(_.words(vrsVideo, /[^, ]+/g), function(value, idx) {
                  var item = new Object();
                  item['position'] = value.split(':')[0];
                  item['thumb'] = value.split('|http')[0].split(':')[2];
                  item['url'] =  value.split('|http')[1].split(':')[1];
                  vrsVideoArr.push(item)
                });
              }
              if(imgspr.length > 1 &&  JSON.parse($('.kt_QuickShopslide').attr('data-curpos')) !== imgsPos){
                var heightVisible = $('.kt_product-images').find('.kt_QuickShopslide').attr('data-min-height');
                imgs += '<ul class="kt_QuickShopslide owl-carousel" data-curpos="['+imgsPos[0]+","+imgsPos[1]+']" data-nav="false" data-dots="true" data-loop="false" data-margin="0" data-items="1" data-video="true" data-min-height="'+heightVisible+'">';
                var dataJs_ = $thisJs.closest('.product-inner').data();                
                var imgsArray = _.words(dataJs_.primgs, /[^, ]+/g), imgsprw = _.words(dataJs_.primgswidth, /[^, ]+/g), imgsprh = _.words(dataJs_.primgsheight, /[^, ]+/g);
                _.forEach(imgsArray, function(value, idx) {
                  if(theme.function.vrsgallery == false || _.toInteger(imgsPos[0]) <= idx+1 && idx+1 < _.toInteger(imgsPos[1]) || _.toInteger(imgsPos[0]) == _.toInteger(imgsPos[1]) && _.toInteger(imgsPos[0]) == idx+1){
                    var fileExt = _.last(value.split('.')), img_url = _.replace(value, '.'+fileExt, '_768x.'+fileExt) ;
                    imgs += '<li class="item-img" style="min-height:'+heightVisible+'px">';
                    imgs += '<img src="'+ _.replace(dataJs_.imgurl, 'kiti', img_url) +'" data-srcfix="'+_.replace(dataJs_.imgurl, 'kiti', value)+'" data-size="'+imgsprw[idx]+'x'+imgsprh[idx]+'" alt="0711">';
                    imgs += '</li>';
                  }
                });
                var vrvideo = _.find(vrsVideoArr, function(o) { return o.position == imgsPos[0] });
                if(vrvideo !== undefined){
                  if((vrvideo.url).indexOf('.mp4') !== -1){
                    imgs += '<li class="item-img video video-lightbox" style="min-height:'+heightVisible+'px">';
                    if(vrvideo.thumb !== undefined){
                      var fileExtThumb = _.last(vrvideo.thumb.split('.')), img_url_thumb = _.replace(vrvideo.thumb, '.'+fileExtThumb, '_768x.'+fileExtThumb);
                      imgs += '<a href="#"><img src="'+img_url_thumb+'" alt=""></a>';
                    }
                    imgs += '<video class="amp-page amp-video-element" id="myVideo" controls="controls">';
                    imgs += '<source type="video/mp4" src="'+vrvideo.url+'"></video>';
                    imgs += '</li>';
                  }else if((vrvideo.url).indexOf('youtube.com') !== -1 || (vrvideo.url).indexOf('vimeo.com') !== -1){
                    imgs += '<li class="item-video video video-lightbox" style="height:'+heightVisible+'px">';
                    imgs += '<a class="owl-video" href="'+vrvideo.url+'"></a>';
                    imgs += '</li>';
                  }                  
                  theme.clickProductPopup.videoClick($('div.kt_floating-quickshop'));
                }
                imgs += '</ul>';
                $('.kt_product-images').find('.kt_QuickShopslide').addClass('first');
                $('.kt_product-images').append(imgs);
                var imagesQuickShopslide = $('.kt_product-images').find('.kt_QuickShopslide:not(.first) img'), loadedImgNum = 0;
                imagesQuickShopslide.imagesLoaded().progress( function(){
                  loadedImgNum += 1;
                  if(loadedImgNum == 1){
                    $('.kt_QuickShopslide.first').animate({'opacity': 0.1}, 300, function(){
                      var owlconfig = $('.kt_product-images').find('.kt_QuickShopslide:not(first)').data();
                      $('.kt_product-images').find('.kt_QuickShopslide:not(first)').owlCarousel(owlconfig);
                      $('.kt_QuickShopslide.first').remove();                      
                      theme.clickProductPopup.initPhotoSwipe($('div.kt_floating-quickshop'));
                    });
                  }
                })
              }
            }
          }
          else if(vrjson.featured_image !== null){            
            if($thisJs.closest('.product-inner').find('.quick-view').length > 0){
              $thisJs.closest('.product-inner').find('.quick-view').attr('data-imgPos', vrjson.featured_image.position);
            }
          }
        }
        $thisJs.closest('.product-inner').find('.ProductPrice-'+ itemData.prid).html(theme.Currency.formatMoney(vrprice, theme.moneyFormat)).removeClass('hidden');
        $thisJs.closest('.product-inner').find('.ProductVaries-'+ itemData.prid).addClass('hidden');
        var pr_vrcompareprice = $thisJs.closest('.product-inner').find('.ComparePrice-'+ itemData.prid);
        if(vrpricec != null && vrpricec !== undefined && vrpricec > vrprice){
          pr_vrcompareprice.removeClass('hidden').html(theme.Currency.formatMoney(vrpricec, theme.moneyFormat));
        }
        else{
          if(pr_vrcompareprice.hasClass('hidden') === false){pr_vrcompareprice.addClass('hidden')}
        }
        if(vrimg !== null && vrimg !== undefined){
          $thisJs.closest('.product-inner').find('.front-image').html('<img class="lazyload" data-src="'+theme.Images.getSizedImageUrl(vrimg,"{width}x")+'" data-widths="[180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048]" data-aspectratio="'+ratio+'" data-sizes="auto" alt="'+vrtitle+'">');
          // Quickshop change image by variant
          if($('.kt_QuickShopslide').length !== 0){
            var itemOwl = $thisJs.closest('.product-inner').find('.owl-item:not(.cloned) img[src*="'+theme.Images.nameImage(vrimg)+'_768x."]').first();
            if($(itemOwl).length == 0){
              itemOwl = $thisJs.closest('.product-inner').find('.owl-item:not(.cloned) img[srcset*="'+theme.Images.nameImage(vrimg)+'_180x."]').first();
            }
            if($(itemOwl).length !== 0){
              var clone_length = ($('.kt_QuickShopslide .owl-item.cloned').length / 2) || 0;
              var slideIndex = $(itemOwl).parents('.owl-item').not('.cloned').index() - clone_length;
              $(".kt_QuickShopslide").trigger("to.owl.carousel", slideIndex);
            }
          }
        }
        var addToCart = $thisJs.closest('.product-inner').find('.kt__add-to-cart');
        addToCart.attr('data-vrid',itemData.vrid).trigger('change');
        if($('div.kt_floating-quickshop .discount-code').length > 0){
          var btn = $('div.kt_floating-quickshop .discount-code a.discount-btn'), hrefcrr = btn.attr('href'), vridcrr = btn.attr('href').split('/')[2].split(':')[0];
          btn.attr('href', _.replace(hrefcrr, vridcrr, itemData.vrid));
        }
        if($thisJs.closest('.product-inner').find('.quick-view').length > 0){
          $thisJs.closest('.product-inner').find('.quick-view').attr('data-vrId', itemData.vrid);
        }
        if(vravailable || vravailable && inventory_quantity <= 0 && inventory_policy != 'deny'){
          if($('div.kt_floating-quickshop').length > 0){
            $('.kt_product-buttons .quantity').removeClass('hidden');
          }
          if(inventory_quantity <= 0 && inventory_policy != 'deny'){
            addToCart.attr('disabled', false).text(theme.productStrings.preOrder);
          }else{
            addToCart.attr('disabled', false).text(theme.productStrings.addToCart);
          }
        }else{
          if($('div.kt_floating-quickshop').length > 0){
            $('.kt_product-buttons .quantity').addClass('hidden');
          }
          addToCart.prop('disabled', true).text(theme.productStrings.soldOut);
        }
        if(theme.function.multiCurrency == true && cookieCurrency !== null && cookieCurrency !== shopCurrency){
          Currency.convertAll(shopCurrency,cookieCurrency,'.product-inner span.money');
        }
      }
    }
    if(elJs.find('.ajaxComplete').length <= 0 && dataJs.opts > 1){
      $('.tooltip.fade.top.in').remove();
      elJs.attr({'data-imgspos':imgsPos, 'data-vrsvideo': vrsVideo})
      elJs.addClass('loading');
      $.ajax({
        url: dataJs.view+'?view=variantQuickshop',
        type: 'GET'
      })
      .done(function(data) {
        //  console.log("success");
        $thisJs.parents('.item').html(data).addClass('ajaxComplete');
      })
      .fail(function() {
        console.log("error variants quick shop");
      })
      .always(function() {
        //  console.log("complete")
        theme.variantChange();
        theme.variantCheckStyle();
        theme.scrollbarVariantGridProduct();
        elJs.find('[data-toggle="tooltip"]').tooltip({container: 'body',trigger: 'hover'});
        elJs.removeClass('loading').find('span[data-vrid='+dataJs.vrid+']').first().trigger('click');
      });
    }
    else{
      if(dataJs.opt == "Opt1Js"){
        optChange.setChange(optChange.setChange(dataJs,'.Opt2Js'),'.Opt3Js');
        optChange.vrChange(dataJs);       
      }
      else if(dataJs.opt == "Opt2Js"){
        $thisJs.parents('.swatches-list').find(".active").removeClass('active');
        $thisJs.parent().addClass('active');
        optChange.setChange(dataJs,'.Opt3Js');
        optChange.vrChange(dataJs);
      }
      else if(dataJs.opt == "Opt3Js"){
        $thisJs.parents('.attributes').find('span[data-vrid='+dataJs.vrid+']').parent().addClass('active');
        optChange.vrChange(dataJs);
      }
    }
  });
})

theme.extraWidth = (function(){
  $('.kt__extra_width').each(function(){
    var width = $(window).outerWidth();
    $(this).css({'margin-left':'-'+ $(this).offset().left+'px','width':width+'px'})
  });
})

theme.mobileTouch = (function(el,callback){
  if(el.length <= 0){return false;}
  var lastX,currentX,deltaX,lastY,currentY,deltaY,scrollable = el;
  // reset touch position on touchstart  
  scrollable.bind('touchstart', function (e){
    currentX = e.originalEvent.touches[0].clientX;
    lastX = currentX;
    currentY = e.originalEvent.touches[0].clientY;
    lastY = currentY;   
  });
  // get movement and scroll the same way
  scrollable.bind('touchmove', function (e){
    currentX = e.originalEvent.touches[0].clientX;
    deltaX = currentX - lastX;
    currentY = e.originalEvent.touches[0].clientY;
    deltaY = currentY - lastY;
    var item = new Object();
    item["lastX"] = lastX;
    item["deltaX"] = deltaX;
    item["currentXMove"] = currentX;
    item["lastY"] = lastY;
    item["deltaY"] = deltaY;
    item["currentYMove"] = currentY;
    callback(item)
  });
  scrollable.bind('touchend', function (e){
    var item = new Object();
    item["lastX"] = lastX;
    item["deltaX"] = deltaX;
    item["currentX"] = currentX;
    item["lastY"] = lastY;
    item["deltaY"] = deltaY;
    item["currentY"] = currentY;    
    callback(item)
  });  
})

$(document).ready(function() {
  var sections = new theme.Sections();
  sections.register('banner-page-section',theme.BannerByPage);
  sections.register('cart-template', theme.Cart);
  sections.register('product', theme.Product);
  sections.register('collection-template', theme.Filters);
  sections.register('header-section', theme.HeaderSection);
  sections.register('map', theme.Maps);
  sections.register('slideshow-section', theme.SlideshowSection);
  sections.register('carousel-section', theme.CarouselSection);
  sections.register('bt_block_masonry', theme.ContentMasorySection);
  sections.register('instagram-section', theme.Instagram);
  sections.register('lookbook-product-single', theme.lookBook);
  sections.register('bt_banner_group-section', theme.BannerMasorySection.carouselBanner);
  if(theme.function.quickview && theme.function.fquickview){
    theme.clickProductPopup.init('li.grid-item a.quickshopMobile, .product-card-small-list a.quickshopMiniList');
  } else if(theme.function.quickview == false && theme.function.fquickview){
    theme.clickProductPopup.init('li.grid-item a.quickshopMobile, .product-item .quick-view, .product-card-small-list a.quickshopMiniList');
  }
  theme.variantImage();
  theme.menuBgChange();  
  theme.TabOwlFadeEffect();
  theme.TabProductFadeEffect();
  theme.Quantity();
  theme.clickOnScrollButton();
  theme.FiltersPjax();
  theme.variantCheckStyle();
  if (theme.MenuReposive.is_mobile() == false){
    theme.scrollbarVariantGridProduct();
  }
  theme.floatingAddToCart();
  theme.extraWidth();
  theme.variantChange();
  theme.stockCountdown('.product-page .kt_progress_bar_pr');

  if ($('.KiTi_Card.style4 .kt_progress_bar_pr').length > 0){
    $.each($('.KiTi_Card.style4 .kt_progress_bar_pr'), function(index, el) {
       var pflashdeal = $(this).closest('.flash-deal').attr('class');
       theme.stockCountdown('.'+pflashdeal.replace(' ', '.')+' .kt_progress_bar_pr');
    });
  }
  $('[data-toggle="tooltip"]').tooltip({container: 'body',trigger: 'hover'});
  $('.mfp-bg.mfp-ready').on('click',function(event) {
    $('.mfp-close').trigger('click')
  });
});
$(window).load(function() {
  theme.DropdownReposive.init('.kiti--DropWindow','.kiti--DropItem','.kiti--DropInner');
  theme.DropdownReposive.init('#ProductSection-product-template .fake_select>ul','.color_sw','.title');
});

$(window).on("resize", function() {
  if(theme.MenuReposive.is_mobile() || $(window).width() <= 768){
    $('.kt-nav').addClass('isMobile').removeClass('notMobile');
  }else{
    $('.kt-nav').removeClass('isMobile').addClass('notMobile');
  }
  if($('#header-ontop .ResizedNavMegaScroll').length > 0){
    $('#header-ontop .ResizedNavMegaScroll').removeClass('#header-ontop ResizedNavMegaScroll')
  }
  if($('.kt_layerfilterGroupsMobile').length > 0){
    if ($(window).width() >= 768 && $('.kt_layerfilterGroupsMobile').html() != ''){
      $('.kt_layerfilterGroupsDesktop').html($('.kt_layerfilterGroupsMobile').html())
    }
    else if($(window).width() < 768 && $('.kt_layerfilterGroupsDesktop').html() != ''){
      $('.kt_layerfilterGroupsMobile').html($('.kt_layerfilterGroupsDesktop').html())
    }
  }
  if($('.front-image').length > 0){$('.front-image').removeAttr('style')}
  theme.Carousel.initCarouselMobile();
  theme.ResizeNavMega.init();
  theme.DropdownReposive.init('.kiti--DropWindow','.kiti--DropItem','.kiti--DropInner');
  theme.DropdownReposive.init('#ProductSection-product-template .fake_select>ul','.color_sw','.title');
  theme.checkProductGrid_Width();
  theme.extraWidth();
});

$(window).scroll(function(){
  theme.clickOnScrollButton();
});

document.addEventListener("DOMContentLoaded", function(event) {
  theme.checkProductGrid_Width();
  var sections = new theme.Sections();
  sections.register('masory-section', theme.ProductsMasorySection);
  sections.register('bt_banner_masonry',theme.BannerMasorySection.MasorySection);
  if($('#instafeed').length){
    var feed = new Instafeed({
      target: 'instafeed',
      get: 'user',
      userId: $('#instafeed').attr('data-user-id'),
      accessToken: $('#instafeed').attr('data-access-token'),
      sortBy: 'most-recent',
      limit: $('#instafeed').attr('data-limit'),
      template: '<li><a href="{{link}}"><img class="lazyload" data-src="{{image}}" /></a><li>'
    });
    feed.run();
  }
});

theme.init = function() {
  theme.customerTemplates.init();

  slate.rte.wrapTable();
  slate.rte.iframeReset();

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $('.in-page-link').on('click', function(evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  $('a[href="#"]').on('click', function(evt) {
    evt.preventDefault();
  });

  $(document).on('click','.box-search.show-icon .icon,.box-search.show-icon .close-box',function(){
    $(this).closest('.box-search').find('.inner').toggle(600);
    $(this).closest('.box-search').toggleClass('open');
  })

  //  Box mobile menu
  function action_addClass() {
    $('body').addClass('box-mobile-menu-open');
    return false;
  }
  function action_removeClass() {
    $('body').removeClass('box-mobile-menu-open');
    return false;
  }
  $(".mobile-navigation").click(action_addClass);
  $("#box-mobile-menu .close-menu, .body-overlay").click(action_removeClass);

  if(theme.MenuReposive.is_mobile()){
    $(document).on('click','.header-icon .iconjs',function(evt){
      evt.preventDefault();
      if($(this).parent().hasClass('open')){
        $(this).parent().removeClass('open');  
      }
      else {
        $('.header-icon.open').removeClass('open');
        $(this).parent().addClass('open');
      }
    })    
    $(document).on('click', function(e){ 
      if ($(e.target).is('.header-icon .iconjs') === false && $(e.target).is('.header-icon *') === false) {
        $('.header-icon').removeClass('open');
      }
    });
  }
  else{
    $(document).on('mousemove','.header-icon',function(){
      $(this).addClass('open');
    })
    .on('mouseout','.header-icon',function(){
      $(this).removeClass('open');
    })
  }
  $(document).on('click','.home-top-category-slide .block-toggle',function(){
    $(this).closest('.home-top-category-slide').find('.block-category-carousel').toggleClass('open');
    $(this).toggleClass('closed');
  })
  $(document).on('click','.sidebar-flexible .button_',function(){
    $(this).closest('.left-sidebar').toggleClass('sidebar-visible');
  })
  $(document).on('click','.background-overlay',function(){
    $('body').find('.closeQuickShop').trigger('click');
  })
};

$(theme.init);